import { __decorate, __extends } from 'tslib';
import * as i0 from '@angular/core';
import { Component, ChangeDetectionStrategy, Injectable, HostListener, Directive, NgModule } from '@angular/core';
import { fromEvent } from 'rxjs';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

/* eslint-disable */
var proxyInputs = function (Cmp, inputs) {
    var Prototype = Cmp.prototype;
    inputs.forEach(function (item) {
        Object.defineProperty(Prototype, item, {
            get: function () {
                return this.el[item];
            },
            set: function (val) {
                var _this = this;
                this.z.runOutsideAngular(function () { return (_this.el[item] = val); });
            },
        });
    });
};
var proxyMethods = function (Cmp, methods) {
    var Prototype = Cmp.prototype;
    methods.forEach(function (methodName) {
        Prototype[methodName] = function () {
            var _this = this;
            var args = arguments;
            return this.z.runOutsideAngular(function () { return _this.el[methodName].apply(_this.el, args); });
        };
    });
};
var proxyOutputs = function (instance, el, events) {
    events.forEach(function (eventName) { return (instance[eventName] = fromEvent(el, eventName)); });
};
// tslint:disable-next-line: only-arrow-functions
function ProxyCmp(opts) {
    var decorator = function (cls) {
        var defineCustomElementFn = opts.defineCustomElementFn, inputs = opts.inputs, methods = opts.methods;
        if (defineCustomElementFn !== undefined) {
            defineCustomElementFn();
        }
        if (inputs) {
            proxyInputs(cls, inputs);
        }
        if (methods) {
            proxyMethods(cls, methods);
        }
        return cls;
    };
    return decorator;
}

var _c0 = ["*"];
var BdsAiBlockResponse = /** @class */ (function () {
    function BdsAiBlockResponse(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['feedbackHelpful', 'feedbackNotHelpful']);
    }
    BdsAiBlockResponse.ɵfac = function BdsAiBlockResponse_Factory(t) { return new (t || BdsAiBlockResponse)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    BdsAiBlockResponse.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: BdsAiBlockResponse, selectors: [["bds-ai-block-response"]], inputs: { dataState: "dataState", dataVariant: "dataVariant" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function BdsAiBlockResponse_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    BdsAiBlockResponse = __decorate([
        ProxyCmp({
            inputs: ['dataState', 'dataVariant']
        })
    ], BdsAiBlockResponse);
    return BdsAiBlockResponse;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BdsAiBlockResponse, [{
        type: Component,
        args: [{
                selector: 'bds-ai-block-response',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['dataState', 'dataVariant'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var BdsAiButton = /** @class */ (function () {
    function BdsAiButton(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    BdsAiButton.ɵfac = function BdsAiButton_Factory(t) { return new (t || BdsAiButton)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    BdsAiButton.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: BdsAiButton, selectors: [["bds-ai-button"]], inputs: { dataTheme: "dataTheme", dataType: "dataType", dataVariant: "dataVariant" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function BdsAiButton_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    BdsAiButton = __decorate([
        ProxyCmp({
            inputs: ['dataTheme', 'dataType', 'dataVariant']
        })
    ], BdsAiButton);
    return BdsAiButton;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BdsAiButton, [{
        type: Component,
        args: [{
                selector: 'bds-ai-button',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['dataTheme', 'dataType', 'dataVariant'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var BdsAiContainer = /** @class */ (function () {
    function BdsAiContainer(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    BdsAiContainer.ɵfac = function BdsAiContainer_Factory(t) { return new (t || BdsAiContainer)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    BdsAiContainer.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: BdsAiContainer, selectors: [["bds-ai-container"]], inputs: { dataTheme: "dataTheme" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function BdsAiContainer_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    BdsAiContainer = __decorate([
        ProxyCmp({
            inputs: ['dataTheme']
        })
    ], BdsAiContainer);
    return BdsAiContainer;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BdsAiContainer, [{
        type: Component,
        args: [{
                selector: 'bds-ai-container',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['dataTheme'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var BdsAiDisclaimer = /** @class */ (function () {
    function BdsAiDisclaimer(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    BdsAiDisclaimer.ɵfac = function BdsAiDisclaimer_Factory(t) { return new (t || BdsAiDisclaimer)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    BdsAiDisclaimer.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: BdsAiDisclaimer, selectors: [["bds-ai-disclaimer"]], inputs: { dataVariant: "dataVariant" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function BdsAiDisclaimer_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    BdsAiDisclaimer = __decorate([
        ProxyCmp({
            inputs: ['dataVariant']
        })
    ], BdsAiDisclaimer);
    return BdsAiDisclaimer;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BdsAiDisclaimer, [{
        type: Component,
        args: [{
                selector: 'bds-ai-disclaimer',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['dataVariant'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var BdsAiFab = /** @class */ (function () {
    function BdsAiFab(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    BdsAiFab.ɵfac = function BdsAiFab_Factory(t) { return new (t || BdsAiFab)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    BdsAiFab.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: BdsAiFab, selectors: [["bds-ai-fab"]], inputs: { dataInput: "dataInput", dataVariant: "dataVariant" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function BdsAiFab_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    BdsAiFab = __decorate([
        ProxyCmp({
            inputs: ['dataInput', 'dataVariant']
        })
    ], BdsAiFab);
    return BdsAiFab;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BdsAiFab, [{
        type: Component,
        args: [{
                selector: 'bds-ai-fab',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['dataInput', 'dataVariant'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var BdsAiFeedback = /** @class */ (function () {
    function BdsAiFeedback(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['feedbackNotHelpful', 'feedbackHelpful']);
    }
    BdsAiFeedback.ɵfac = function BdsAiFeedback_Factory(t) { return new (t || BdsAiFeedback)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    BdsAiFeedback.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: BdsAiFeedback, selectors: [["bds-ai-feedback"]], inputs: { dataState: "dataState", dataVariant: "dataVariant" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function BdsAiFeedback_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    BdsAiFeedback = __decorate([
        ProxyCmp({
            inputs: ['dataState', 'dataVariant']
        })
    ], BdsAiFeedback);
    return BdsAiFeedback;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BdsAiFeedback, [{
        type: Component,
        args: [{
                selector: 'bds-ai-feedback',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['dataState', 'dataVariant'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var BdsAiGenerating = /** @class */ (function () {
    function BdsAiGenerating(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    BdsAiGenerating.ɵfac = function BdsAiGenerating_Factory(t) { return new (t || BdsAiGenerating)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    BdsAiGenerating.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: BdsAiGenerating, selectors: [["bds-ai-generating"]], ngContentSelectors: _c0, decls: 1, vars: 0, template: function BdsAiGenerating_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    BdsAiGenerating = __decorate([
        ProxyCmp({})
    ], BdsAiGenerating);
    return BdsAiGenerating;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BdsAiGenerating, [{
        type: Component,
        args: [{
                selector: 'bds-ai-generating',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: [],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var BdsAiHeader = /** @class */ (function () {
    function BdsAiHeader(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    BdsAiHeader.ɵfac = function BdsAiHeader_Factory(t) { return new (t || BdsAiHeader)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    BdsAiHeader.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: BdsAiHeader, selectors: [["bds-ai-header"]], ngContentSelectors: _c0, decls: 1, vars: 0, template: function BdsAiHeader_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    BdsAiHeader = __decorate([
        ProxyCmp({})
    ], BdsAiHeader);
    return BdsAiHeader;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BdsAiHeader, [{
        type: Component,
        args: [{
                selector: 'bds-ai-header',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: [],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var BdsAiHeaderButton = /** @class */ (function () {
    function BdsAiHeaderButton(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['buttonClicked']);
    }
    BdsAiHeaderButton.ɵfac = function BdsAiHeaderButton_Factory(t) { return new (t || BdsAiHeaderButton)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    BdsAiHeaderButton.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: BdsAiHeaderButton, selectors: [["bds-ai-header-button"]], inputs: { dataType: "dataType", dataVariant: "dataVariant", position: "position" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function BdsAiHeaderButton_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    BdsAiHeaderButton = __decorate([
        ProxyCmp({
            inputs: ['dataType', 'dataVariant', 'position']
        })
    ], BdsAiHeaderButton);
    return BdsAiHeaderButton;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BdsAiHeaderButton, [{
        type: Component,
        args: [{
                selector: 'bds-ai-header-button',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['dataType', 'dataVariant', 'position'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var BdsAiHeaderTitle = /** @class */ (function () {
    function BdsAiHeaderTitle(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    BdsAiHeaderTitle.ɵfac = function BdsAiHeaderTitle_Factory(t) { return new (t || BdsAiHeaderTitle)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    BdsAiHeaderTitle.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: BdsAiHeaderTitle, selectors: [["bds-ai-header-title"]], ngContentSelectors: _c0, decls: 1, vars: 0, template: function BdsAiHeaderTitle_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    BdsAiHeaderTitle = __decorate([
        ProxyCmp({})
    ], BdsAiHeaderTitle);
    return BdsAiHeaderTitle;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BdsAiHeaderTitle, [{
        type: Component,
        args: [{
                selector: 'bds-ai-header-title',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: [],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var BdsAiMessages = /** @class */ (function () {
    function BdsAiMessages(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    BdsAiMessages.ɵfac = function BdsAiMessages_Factory(t) { return new (t || BdsAiMessages)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    BdsAiMessages.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: BdsAiMessages, selectors: [["bds-ai-messages"]], ngContentSelectors: _c0, decls: 1, vars: 0, template: function BdsAiMessages_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    BdsAiMessages = __decorate([
        ProxyCmp({})
    ], BdsAiMessages);
    return BdsAiMessages;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BdsAiMessages, [{
        type: Component,
        args: [{
                selector: 'bds-ai-messages',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: [],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var BdsAiRule = /** @class */ (function () {
    function BdsAiRule(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    BdsAiRule.ɵfac = function BdsAiRule_Factory(t) { return new (t || BdsAiRule)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    BdsAiRule.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: BdsAiRule, selectors: [["bds-ai-rule"]], ngContentSelectors: _c0, decls: 1, vars: 0, template: function BdsAiRule_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    BdsAiRule = __decorate([
        ProxyCmp({})
    ], BdsAiRule);
    return BdsAiRule;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BdsAiRule, [{
        type: Component,
        args: [{
                selector: 'bds-ai-rule',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: [],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var BdsAiSpinner = /** @class */ (function () {
    function BdsAiSpinner(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    BdsAiSpinner.ɵfac = function BdsAiSpinner_Factory(t) { return new (t || BdsAiSpinner)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    BdsAiSpinner.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: BdsAiSpinner, selectors: [["bds-ai-spinner"]], inputs: { dataTheme: "dataTheme" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function BdsAiSpinner_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    BdsAiSpinner = __decorate([
        ProxyCmp({
            inputs: ['dataTheme']
        })
    ], BdsAiSpinner);
    return BdsAiSpinner;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BdsAiSpinner, [{
        type: Component,
        args: [{
                selector: 'bds-ai-spinner',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['dataTheme'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var BdsAiSuggestedPrompt = /** @class */ (function () {
    function BdsAiSuggestedPrompt(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['suggestedPromptClick']);
    }
    BdsAiSuggestedPrompt.ɵfac = function BdsAiSuggestedPrompt_Factory(t) { return new (t || BdsAiSuggestedPrompt)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    BdsAiSuggestedPrompt.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: BdsAiSuggestedPrompt, selectors: [["bds-ai-suggested-prompt"]], inputs: { dataState: "dataState" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function BdsAiSuggestedPrompt_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    BdsAiSuggestedPrompt = __decorate([
        ProxyCmp({
            inputs: ['dataState']
        })
    ], BdsAiSuggestedPrompt);
    return BdsAiSuggestedPrompt;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BdsAiSuggestedPrompt, [{
        type: Component,
        args: [{
                selector: 'bds-ai-suggested-prompt',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['dataState'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var BdsAiText = /** @class */ (function () {
    function BdsAiText(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    BdsAiText.ɵfac = function BdsAiText_Factory(t) { return new (t || BdsAiText)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    BdsAiText.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: BdsAiText, selectors: [["bds-ai-text"]], inputs: { dataType: "dataType", dataVariant: "dataVariant" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function BdsAiText_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    BdsAiText = __decorate([
        ProxyCmp({
            inputs: ['dataType', 'dataVariant']
        })
    ], BdsAiText);
    return BdsAiText;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BdsAiText, [{
        type: Component,
        args: [{
                selector: 'bds-ai-text',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['dataType', 'dataVariant'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var BdsAiUserResponse = /** @class */ (function () {
    function BdsAiUserResponse(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    BdsAiUserResponse.ɵfac = function BdsAiUserResponse_Factory(t) { return new (t || BdsAiUserResponse)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    BdsAiUserResponse.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: BdsAiUserResponse, selectors: [["bds-ai-user-response"]], ngContentSelectors: _c0, decls: 1, vars: 0, template: function BdsAiUserResponse_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    BdsAiUserResponse = __decorate([
        ProxyCmp({})
    ], BdsAiUserResponse);
    return BdsAiUserResponse;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BdsAiUserResponse, [{
        type: Component,
        args: [{
                selector: 'bds-ai-user-response',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: [],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var BdsBrand = /** @class */ (function () {
    function BdsBrand(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    BdsBrand.ɵfac = function BdsBrand_Factory(t) { return new (t || BdsBrand)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    BdsBrand.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: BdsBrand, selectors: [["bds-brand"]], ngContentSelectors: _c0, decls: 1, vars: 0, template: function BdsBrand_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    BdsBrand = __decorate([
        ProxyCmp({})
    ], BdsBrand);
    return BdsBrand;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BdsBrand, [{
        type: Component,
        args: [{
                selector: 'bds-brand',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: [],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var BdsColors = /** @class */ (function () {
    function BdsColors(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    BdsColors.ɵfac = function BdsColors_Factory(t) { return new (t || BdsColors)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    BdsColors.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: BdsColors, selectors: [["bds-colors"]], ngContentSelectors: _c0, decls: 1, vars: 0, template: function BdsColors_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    BdsColors = __decorate([
        ProxyCmp({})
    ], BdsColors);
    return BdsColors;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BdsColors, [{
        type: Component,
        args: [{
                selector: 'bds-colors',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: [],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var BdsEffects = /** @class */ (function () {
    function BdsEffects(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    BdsEffects.ɵfac = function BdsEffects_Factory(t) { return new (t || BdsEffects)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    BdsEffects.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: BdsEffects, selectors: [["bds-effects"]], ngContentSelectors: _c0, decls: 1, vars: 0, template: function BdsEffects_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    BdsEffects = __decorate([
        ProxyCmp({})
    ], BdsEffects);
    return BdsEffects;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BdsEffects, [{
        type: Component,
        args: [{
                selector: 'bds-effects',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: [],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var BdsFlex = /** @class */ (function () {
    function BdsFlex(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    BdsFlex.ɵfac = function BdsFlex_Factory(t) { return new (t || BdsFlex)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    BdsFlex.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: BdsFlex, selectors: [["bds-flex"]], ngContentSelectors: _c0, decls: 1, vars: 0, template: function BdsFlex_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    BdsFlex = __decorate([
        ProxyCmp({})
    ], BdsFlex);
    return BdsFlex;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BdsFlex, [{
        type: Component,
        args: [{
                selector: 'bds-flex',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: [],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var BdsGrids = /** @class */ (function () {
    function BdsGrids(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    BdsGrids.ɵfac = function BdsGrids_Factory(t) { return new (t || BdsGrids)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    BdsGrids.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: BdsGrids, selectors: [["bds-grids"]], ngContentSelectors: _c0, decls: 1, vars: 0, template: function BdsGrids_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    BdsGrids = __decorate([
        ProxyCmp({})
    ], BdsGrids);
    return BdsGrids;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BdsGrids, [{
        type: Component,
        args: [{
                selector: 'bds-grids',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: [],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var BdsSpacing = /** @class */ (function () {
    function BdsSpacing(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    BdsSpacing.ɵfac = function BdsSpacing_Factory(t) { return new (t || BdsSpacing)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    BdsSpacing.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: BdsSpacing, selectors: [["bds-spacing"]], ngContentSelectors: _c0, decls: 1, vars: 0, template: function BdsSpacing_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    BdsSpacing = __decorate([
        ProxyCmp({})
    ], BdsSpacing);
    return BdsSpacing;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BdsSpacing, [{
        type: Component,
        args: [{
                selector: 'bds-spacing',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: [],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var BdsTypography = /** @class */ (function () {
    function BdsTypography(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    BdsTypography.ɵfac = function BdsTypography_Factory(t) { return new (t || BdsTypography)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    BdsTypography.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: BdsTypography, selectors: [["bds-typography"]], ngContentSelectors: _c0, decls: 1, vars: 0, template: function BdsTypography_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    BdsTypography = __decorate([
        ProxyCmp({})
    ], BdsTypography);
    return BdsTypography;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BdsTypography, [{
        type: Component,
        args: [{
                selector: 'bds-typography',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: [],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var HrbAccentSection = /** @class */ (function () {
    function HrbAccentSection(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    HrbAccentSection.ɵfac = function HrbAccentSection_Factory(t) { return new (t || HrbAccentSection)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    HrbAccentSection.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HrbAccentSection, selectors: [["hrb-accent-section"]], ngContentSelectors: _c0, decls: 1, vars: 0, template: function HrbAccentSection_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    HrbAccentSection = __decorate([
        ProxyCmp({})
    ], HrbAccentSection);
    return HrbAccentSection;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HrbAccentSection, [{
        type: Component,
        args: [{
                selector: 'hrb-accent-section',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: [],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var HrbAccordion = /** @class */ (function () {
    function HrbAccordion(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    HrbAccordion.ɵfac = function HrbAccordion_Factory(t) { return new (t || HrbAccordion)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    HrbAccordion.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HrbAccordion, selectors: [["hrb-accordion"]], inputs: { type: "type" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function HrbAccordion_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    HrbAccordion = __decorate([
        ProxyCmp({
            inputs: ['type']
        })
    ], HrbAccordion);
    return HrbAccordion;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HrbAccordion, [{
        type: Component,
        args: [{
                selector: 'hrb-accordion',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['type'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var HrbAccordionItem = /** @class */ (function () {
    function HrbAccordionItem(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['accordionToggled']);
    }
    HrbAccordionItem.ɵfac = function HrbAccordionItem_Factory(t) { return new (t || HrbAccordionItem)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    HrbAccordionItem.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HrbAccordionItem, selectors: [["hrb-accordion-item"]], inputs: { accordionId: "accordionId", autoIdentifier: "autoIdentifier", disabled: "disabled", headerAs: "headerAs", headerText: "headerText", previewText: "previewText", subnavHeaderStyle: "subnavHeaderStyle", type: "type" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function HrbAccordionItem_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    HrbAccordionItem = __decorate([
        ProxyCmp({
            inputs: ['accordionId', 'autoIdentifier', 'disabled', 'headerAs', 'headerText', 'previewText', 'subnavHeaderStyle', 'type'],
            methods: ['setIsExpanded', 'updateHeight']
        })
    ], HrbAccordionItem);
    return HrbAccordionItem;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HrbAccordionItem, [{
        type: Component,
        args: [{
                selector: 'hrb-accordion-item',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['accordionId', 'autoIdentifier', 'disabled', 'headerAs', 'headerText', 'previewText', 'subnavHeaderStyle', 'type'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var HrbAnimationsGlobal = /** @class */ (function () {
    function HrbAnimationsGlobal(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    HrbAnimationsGlobal.ɵfac = function HrbAnimationsGlobal_Factory(t) { return new (t || HrbAnimationsGlobal)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    HrbAnimationsGlobal.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HrbAnimationsGlobal, selectors: [["hrb-animations-global"]], ngContentSelectors: _c0, decls: 1, vars: 0, template: function HrbAnimationsGlobal_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    HrbAnimationsGlobal = __decorate([
        ProxyCmp({})
    ], HrbAnimationsGlobal);
    return HrbAnimationsGlobal;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HrbAnimationsGlobal, [{
        type: Component,
        args: [{
                selector: 'hrb-animations-global',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: [],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var HrbAttachmentItem = /** @class */ (function () {
    function HrbAttachmentItem(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['previewAttachment', 'deleteAttachment']);
    }
    HrbAttachmentItem.ɵfac = function HrbAttachmentItem_Factory(t) { return new (t || HrbAttachmentItem)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    HrbAttachmentItem.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HrbAttachmentItem, selectors: [["hrb-attachment-item"]], inputs: { FileName: "FileName", FileSize: "FileSize", autoIdentifier: "autoIdentifier", isEditable: "isEditable" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function HrbAttachmentItem_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    HrbAttachmentItem = __decorate([
        ProxyCmp({
            inputs: ['FileName', 'FileSize', 'autoIdentifier', 'isEditable']
        })
    ], HrbAttachmentItem);
    return HrbAttachmentItem;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HrbAttachmentItem, [{
        type: Component,
        args: [{
                selector: 'hrb-attachment-item',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['FileName', 'FileSize', 'autoIdentifier', 'isEditable'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var HrbAttachmentList = /** @class */ (function () {
    function HrbAttachmentList(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['attachmentListToggle']);
    }
    HrbAttachmentList.ɵfac = function HrbAttachmentList_Factory(t) { return new (t || HrbAttachmentList)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    HrbAttachmentList.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HrbAttachmentList, selectors: [["hrb-attachment-list"]], inputs: { attachments: "attachments", collapsed: "collapsed", edit: "edit", itemCount: "itemCount" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function HrbAttachmentList_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    HrbAttachmentList = __decorate([
        ProxyCmp({
            inputs: ['attachments', 'collapsed', 'edit', 'itemCount'],
            methods: ['toggleList']
        })
    ], HrbAttachmentList);
    return HrbAttachmentList;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HrbAttachmentList, [{
        type: Component,
        args: [{
                selector: 'hrb-attachment-list',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['attachments', 'collapsed', 'edit', 'itemCount'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var HrbAutocomplete = /** @class */ (function () {
    function HrbAutocomplete(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    HrbAutocomplete.ɵfac = function HrbAutocomplete_Factory(t) { return new (t || HrbAutocomplete)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    HrbAutocomplete.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HrbAutocomplete, selectors: [["hrb-autocomplete"]], inputs: { debounce: "debounce", disabled: "disabled", errorLabel: "errorLabel", hasError: "hasError", helperText: "helperText", inputId: "inputId", keys: "keys", label: "label", loading: "loading", maxResults: "maxResults", name: "name", readonly: "readonly", required: "required", threshold: "threshold", type: "type", value: "value" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function HrbAutocomplete_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    HrbAutocomplete = __decorate([
        ProxyCmp({
            inputs: ['debounce', 'disabled', 'errorLabel', 'hasError', 'helperText', 'inputId', 'keys', 'label', 'loading', 'maxResults', 'name', 'readonly', 'required', 'threshold', 'type', 'value'],
            methods: ['getElement', 'setData', 'setFocus']
        })
    ], HrbAutocomplete);
    return HrbAutocomplete;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HrbAutocomplete, [{
        type: Component,
        args: [{
                selector: 'hrb-autocomplete',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['debounce', 'disabled', 'errorLabel', 'hasError', 'helperText', 'inputId', 'keys', 'label', 'loading', 'maxResults', 'name', 'readonly', 'required', 'threshold', 'type', 'value'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var HrbAvatar = /** @class */ (function () {
    function HrbAvatar(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    HrbAvatar.ɵfac = function HrbAvatar_Factory(t) { return new (t || HrbAvatar)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    HrbAvatar.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HrbAvatar, selectors: [["hrb-avatar"]], inputs: { avatarIconTheme: "avatarIconTheme", icon: "icon", image: "image", imageAlt: "imageAlt", pAriaLabel: "pAriaLabel", size: "size", text: "text", theme: "theme" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function HrbAvatar_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    HrbAvatar = __decorate([
        ProxyCmp({
            inputs: ['avatarIconTheme', 'icon', 'image', 'imageAlt', 'pAriaLabel', 'size', 'text', 'theme']
        })
    ], HrbAvatar);
    return HrbAvatar;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HrbAvatar, [{
        type: Component,
        args: [{
                selector: 'hrb-avatar',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['avatarIconTheme', 'icon', 'image', 'imageAlt', 'pAriaLabel', 'size', 'text', 'theme'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var HrbBadgeCount = /** @class */ (function () {
    function HrbBadgeCount(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    HrbBadgeCount.ɵfac = function HrbBadgeCount_Factory(t) { return new (t || HrbBadgeCount)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    HrbBadgeCount.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HrbBadgeCount, selectors: [["hrb-badge-count"]], inputs: { count: "count", countPosition: "countPosition", iconName: "iconName", iconPosition: "iconPosition", iconTheme: "iconTheme" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function HrbBadgeCount_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    HrbBadgeCount = __decorate([
        ProxyCmp({
            inputs: ['count', 'countPosition', 'iconName', 'iconPosition', 'iconTheme']
        })
    ], HrbBadgeCount);
    return HrbBadgeCount;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HrbBadgeCount, [{
        type: Component,
        args: [{
                selector: 'hrb-badge-count',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['count', 'countPosition', 'iconName', 'iconPosition', 'iconTheme'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var HrbBadgeLabel = /** @class */ (function () {
    function HrbBadgeLabel(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    HrbBadgeLabel.ɵfac = function HrbBadgeLabel_Factory(t) { return new (t || HrbBadgeLabel)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    HrbBadgeLabel.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HrbBadgeLabel, selectors: [["hrb-badge-label"]], inputs: { badgeCallout: "badgeCallout", badgeNote: "badgeNote", badgeSubtitle: "badgeSubtitle", badgeTitle: "badgeTitle", icon: "icon", iconTheme: "iconTheme", image: "image", imageAlt: "imageAlt", size: "size", text: "text", theme: "theme" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function HrbBadgeLabel_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    HrbBadgeLabel = __decorate([
        ProxyCmp({
            inputs: ['badgeCallout', 'badgeNote', 'badgeSubtitle', 'badgeTitle', 'icon', 'iconTheme', 'image', 'imageAlt', 'size', 'text', 'theme']
        })
    ], HrbBadgeLabel);
    return HrbBadgeLabel;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HrbBadgeLabel, [{
        type: Component,
        args: [{
                selector: 'hrb-badge-label',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['badgeCallout', 'badgeNote', 'badgeSubtitle', 'badgeTitle', 'icon', 'iconTheme', 'image', 'imageAlt', 'size', 'text', 'theme'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var HrbBanner = /** @class */ (function () {
    function HrbBanner(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['bannerClosed']);
    }
    HrbBanner.ɵfac = function HrbBanner_Factory(t) { return new (t || HrbBanner)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    HrbBanner.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HrbBanner, selectors: [["hrb-banner"]], inputs: { avatarIcon: "avatarIcon", avatarImage: "avatarImage", avatarImageAlt: "avatarImageAlt", avatarLabel: "avatarLabel", avatarText: "avatarText", avatarTheme: "avatarTheme", bannerDescription: "bannerDescription", bannerLink: "bannerLink", bannerLinkUrl: "bannerLinkUrl", dataState: "dataState", dismissable: "dismissable", theme: "theme", type: "type" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function HrbBanner_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    HrbBanner = __decorate([
        ProxyCmp({
            inputs: ['avatarIcon', 'avatarImage', 'avatarImageAlt', 'avatarLabel', 'avatarText', 'avatarTheme', 'bannerDescription', 'bannerLink', 'bannerLinkUrl', 'dataState', 'dismissable', 'theme', 'type']
        })
    ], HrbBanner);
    return HrbBanner;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HrbBanner, [{
        type: Component,
        args: [{
                selector: 'hrb-banner',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['avatarIcon', 'avatarImage', 'avatarImageAlt', 'avatarLabel', 'avatarText', 'avatarTheme', 'bannerDescription', 'bannerLink', 'bannerLinkUrl', 'dataState', 'dismissable', 'theme', 'type'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var HrbBrandSection = /** @class */ (function () {
    function HrbBrandSection(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    HrbBrandSection.ɵfac = function HrbBrandSection_Factory(t) { return new (t || HrbBrandSection)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    HrbBrandSection.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HrbBrandSection, selectors: [["hrb-brand-section"]], ngContentSelectors: _c0, decls: 1, vars: 0, template: function HrbBrandSection_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    HrbBrandSection = __decorate([
        ProxyCmp({})
    ], HrbBrandSection);
    return HrbBrandSection;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HrbBrandSection, [{
        type: Component,
        args: [{
                selector: 'hrb-brand-section',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: [],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var HrbButton = /** @class */ (function () {
    function HrbButton(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    HrbButton.ɵfac = function HrbButton_Factory(t) { return new (t || HrbButton)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    HrbButton.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HrbButton, selectors: [["hrb-button"]], inputs: { autoIdentifier: "autoIdentifier", dataType: "dataType", disabled: "disabled", fullWidth: "fullWidth", icon: "icon", iconPosition: "iconPosition", loading: "loading", pAriaLabel: "pAriaLabel", pAriaLabelledby: "pAriaLabelledby", pAriaPressed: "pAriaPressed", pAriaRole: "pAriaRole", qualifier: "qualifier", secondary: "secondary", size: "size", theme: "theme", type: "type", variant: "variant" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function HrbButton_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    HrbButton = __decorate([
        ProxyCmp({
            inputs: ['autoIdentifier', 'dataType', 'disabled', 'fullWidth', 'icon', 'iconPosition', 'loading', 'pAriaLabel', 'pAriaLabelledby', 'pAriaPressed', 'pAriaRole', 'qualifier', 'secondary', 'size', 'theme', 'type', 'variant']
        })
    ], HrbButton);
    return HrbButton;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HrbButton, [{
        type: Component,
        args: [{
                selector: 'hrb-button',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['autoIdentifier', 'dataType', 'disabled', 'fullWidth', 'icon', 'iconPosition', 'loading', 'pAriaLabel', 'pAriaLabelledby', 'pAriaPressed', 'pAriaRole', 'qualifier', 'secondary', 'size', 'theme', 'type', 'variant'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var HrbCard = /** @class */ (function () {
    function HrbCard(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    HrbCard.ɵfac = function HrbCard_Factory(t) { return new (t || HrbCard)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    HrbCard.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HrbCard, selectors: [["hrb-card"]], inputs: { animateBoot: "animateBoot", animateHat: "animateHat", as: "as", dataVariant: "dataVariant", hasBoot: "hasBoot", hasHat: "hasHat", theme: "theme" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function HrbCard_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    HrbCard = __decorate([
        ProxyCmp({
            inputs: ['animateBoot', 'animateHat', 'as', 'dataVariant', 'hasBoot', 'hasHat', 'theme']
        })
    ], HrbCard);
    return HrbCard;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HrbCard, [{
        type: Component,
        args: [{
                selector: 'hrb-card',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['animateBoot', 'animateHat', 'as', 'dataVariant', 'hasBoot', 'hasHat', 'theme'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var HrbCardContent = /** @class */ (function () {
    function HrbCardContent(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    HrbCardContent.ɵfac = function HrbCardContent_Factory(t) { return new (t || HrbCardContent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    HrbCardContent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HrbCardContent, selectors: [["hrb-card-content"]], inputs: { padding: "padding" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function HrbCardContent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    HrbCardContent = __decorate([
        ProxyCmp({
            inputs: ['padding']
        })
    ], HrbCardContent);
    return HrbCardContent;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HrbCardContent, [{
        type: Component,
        args: [{
                selector: 'hrb-card-content',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['padding'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var HrbCardDocument = /** @class */ (function () {
    function HrbCardDocument(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['headerClicked']);
    }
    HrbCardDocument.ɵfac = function HrbCardDocument_Factory(t) { return new (t || HrbCardDocument)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    HrbCardDocument.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HrbCardDocument, selectors: [["hrb-card-document"]], inputs: { addedBy: "addedBy", categoryName: "categoryName", fileName: "fileName", headerAs: "headerAs", headerLink: "headerLink", isLoading: "isLoading", layout: "layout", thumbAlt: "thumbAlt", thumbSrc: "thumbSrc", uploadDate: "uploadDate" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function HrbCardDocument_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    HrbCardDocument = __decorate([
        ProxyCmp({
            inputs: ['addedBy', 'categoryName', 'fileName', 'headerAs', 'headerLink', 'isLoading', 'layout', 'thumbAlt', 'thumbSrc', 'uploadDate']
        })
    ], HrbCardDocument);
    return HrbCardDocument;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HrbCardDocument, [{
        type: Component,
        args: [{
                selector: 'hrb-card-document',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['addedBy', 'categoryName', 'fileName', 'headerAs', 'headerLink', 'isLoading', 'layout', 'thumbAlt', 'thumbSrc', 'uploadDate'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var HrbCardExpandable = /** @class */ (function () {
    function HrbCardExpandable(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['hrbOpen', 'hrbClose']);
    }
    HrbCardExpandable.ɵfac = function HrbCardExpandable_Factory(t) { return new (t || HrbCardExpandable)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    HrbCardExpandable.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HrbCardExpandable, selectors: [["hrb-card-expandable"]], inputs: { closeIcon: "closeIcon", icon: "icon", theme: "theme" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function HrbCardExpandable_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    HrbCardExpandable = __decorate([
        ProxyCmp({
            inputs: ['closeIcon', 'icon', 'theme'],
            methods: ['close', 'open', 'controlHeight']
        })
    ], HrbCardExpandable);
    return HrbCardExpandable;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HrbCardExpandable, [{
        type: Component,
        args: [{
                selector: 'hrb-card-expandable',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['closeIcon', 'icon', 'theme'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var HrbCheckbox = /** @class */ (function () {
    function HrbCheckbox(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['hrbBlur', 'hrbChange', 'hrbFocus', 'hrbInput']);
    }
    HrbCheckbox.ɵfac = function HrbCheckbox_Factory(t) { return new (t || HrbCheckbox)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    HrbCheckbox.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HrbCheckbox, selectors: [["hrb-checkbox"]], inputs: { autoIdentifier: "autoIdentifier", checked: "checked", dataVariant: "dataVariant", disabled: "disabled", errorLabel: "errorLabel", hasError: "hasError", helperText: "helperText", inputId: "inputId", label: "label", name: "name", required: "required", theme: "theme", value: "value" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function HrbCheckbox_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    HrbCheckbox = __decorate([
        ProxyCmp({
            inputs: ['autoIdentifier', 'checked', 'dataVariant', 'disabled', 'errorLabel', 'hasError', 'helperText', 'inputId', 'label', 'name', 'required', 'theme', 'value'],
            methods: ['getElement', 'setFocus']
        })
    ], HrbCheckbox);
    return HrbCheckbox;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HrbCheckbox, [{
        type: Component,
        args: [{
                selector: 'hrb-checkbox',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['autoIdentifier', 'checked', 'dataVariant', 'disabled', 'errorLabel', 'hasError', 'helperText', 'inputId', 'label', 'name', 'required', 'theme', 'value'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var HrbCheckboxGroup = /** @class */ (function () {
    function HrbCheckboxGroup(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    HrbCheckboxGroup.ɵfac = function HrbCheckboxGroup_Factory(t) { return new (t || HrbCheckboxGroup)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    HrbCheckboxGroup.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HrbCheckboxGroup, selectors: [["hrb-checkbox-group"]], ngContentSelectors: _c0, decls: 1, vars: 0, template: function HrbCheckboxGroup_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    HrbCheckboxGroup = __decorate([
        ProxyCmp({})
    ], HrbCheckboxGroup);
    return HrbCheckboxGroup;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HrbCheckboxGroup, [{
        type: Component,
        args: [{
                selector: 'hrb-checkbox-group',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: [],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var HrbCheckboxGroupColumns = /** @class */ (function () {
    function HrbCheckboxGroupColumns(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    HrbCheckboxGroupColumns.ɵfac = function HrbCheckboxGroupColumns_Factory(t) { return new (t || HrbCheckboxGroupColumns)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    HrbCheckboxGroupColumns.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HrbCheckboxGroupColumns, selectors: [["hrb-checkbox-group-columns"]], ngContentSelectors: _c0, decls: 1, vars: 0, template: function HrbCheckboxGroupColumns_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    HrbCheckboxGroupColumns = __decorate([
        ProxyCmp({})
    ], HrbCheckboxGroupColumns);
    return HrbCheckboxGroupColumns;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HrbCheckboxGroupColumns, [{
        type: Component,
        args: [{
                selector: 'hrb-checkbox-group-columns',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: [],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var HrbCheckboxGroupError = /** @class */ (function () {
    function HrbCheckboxGroupError(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    HrbCheckboxGroupError.ɵfac = function HrbCheckboxGroupError_Factory(t) { return new (t || HrbCheckboxGroupError)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    HrbCheckboxGroupError.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HrbCheckboxGroupError, selectors: [["hrb-checkbox-group-error"]], ngContentSelectors: _c0, decls: 1, vars: 0, template: function HrbCheckboxGroupError_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    HrbCheckboxGroupError = __decorate([
        ProxyCmp({})
    ], HrbCheckboxGroupError);
    return HrbCheckboxGroupError;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HrbCheckboxGroupError, [{
        type: Component,
        args: [{
                selector: 'hrb-checkbox-group-error',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: [],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var HrbCheckboxGroupHeader = /** @class */ (function () {
    function HrbCheckboxGroupHeader(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    HrbCheckboxGroupHeader.ɵfac = function HrbCheckboxGroupHeader_Factory(t) { return new (t || HrbCheckboxGroupHeader)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    HrbCheckboxGroupHeader.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HrbCheckboxGroupHeader, selectors: [["hrb-checkbox-group-header"]], ngContentSelectors: _c0, decls: 1, vars: 0, template: function HrbCheckboxGroupHeader_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    HrbCheckboxGroupHeader = __decorate([
        ProxyCmp({})
    ], HrbCheckboxGroupHeader);
    return HrbCheckboxGroupHeader;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HrbCheckboxGroupHeader, [{
        type: Component,
        args: [{
                selector: 'hrb-checkbox-group-header',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: [],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var HrbCheckboxGroupHelper = /** @class */ (function () {
    function HrbCheckboxGroupHelper(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    HrbCheckboxGroupHelper.ɵfac = function HrbCheckboxGroupHelper_Factory(t) { return new (t || HrbCheckboxGroupHelper)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    HrbCheckboxGroupHelper.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HrbCheckboxGroupHelper, selectors: [["hrb-checkbox-group-helper"]], ngContentSelectors: _c0, decls: 1, vars: 0, template: function HrbCheckboxGroupHelper_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    HrbCheckboxGroupHelper = __decorate([
        ProxyCmp({})
    ], HrbCheckboxGroupHelper);
    return HrbCheckboxGroupHelper;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HrbCheckboxGroupHelper, [{
        type: Component,
        args: [{
                selector: 'hrb-checkbox-group-helper',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: [],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var HrbCircleButton = /** @class */ (function () {
    function HrbCircleButton(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    HrbCircleButton.ɵfac = function HrbCircleButton_Factory(t) { return new (t || HrbCircleButton)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    HrbCircleButton.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HrbCircleButton, selectors: [["hrb-circle-button"]], inputs: { as: "as", autoIdentifier: "autoIdentifier", disabled: "disabled", href: "href", pAriaControls: "pAriaControls", pAriaExpaned: "pAriaExpaned", pAriaLabel: "pAriaLabel", pAriaLabelledby: "pAriaLabelledby", pAriaRole: "pAriaRole", pTabIndex: "pTabIndex", rel: "rel", size: "size", target: "target", theme: "theme", transparent: "transparent", type: "type" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function HrbCircleButton_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    HrbCircleButton = __decorate([
        ProxyCmp({
            inputs: ['as', 'autoIdentifier', 'disabled', 'href', 'pAriaControls', 'pAriaExpaned', 'pAriaLabel', 'pAriaLabelledby', 'pAriaRole', 'pTabIndex', 'rel', 'size', 'target', 'theme', 'transparent', 'type']
        })
    ], HrbCircleButton);
    return HrbCircleButton;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HrbCircleButton, [{
        type: Component,
        args: [{
                selector: 'hrb-circle-button',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['as', 'autoIdentifier', 'disabled', 'href', 'pAriaControls', 'pAriaExpaned', 'pAriaLabel', 'pAriaLabelledby', 'pAriaRole', 'pTabIndex', 'rel', 'size', 'target', 'theme', 'transparent', 'type'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var HrbCircleButtonWithLabel = /** @class */ (function () {
    function HrbCircleButtonWithLabel(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    HrbCircleButtonWithLabel.ɵfac = function HrbCircleButtonWithLabel_Factory(t) { return new (t || HrbCircleButtonWithLabel)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    HrbCircleButtonWithLabel.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HrbCircleButtonWithLabel, selectors: [["hrb-circle-button-with-label"]], inputs: { as: "as", disabled: "disabled", href: "href", icon: "icon", pAriaLabel: "pAriaLabel", pAriaLabelledby: "pAriaLabelledby", pAriaRole: "pAriaRole", rel: "rel", target: "target", theme: "theme", type: "type" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function HrbCircleButtonWithLabel_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    HrbCircleButtonWithLabel = __decorate([
        ProxyCmp({
            inputs: ['as', 'disabled', 'href', 'icon', 'pAriaLabel', 'pAriaLabelledby', 'pAriaRole', 'rel', 'target', 'theme', 'type']
        })
    ], HrbCircleButtonWithLabel);
    return HrbCircleButtonWithLabel;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HrbCircleButtonWithLabel, [{
        type: Component,
        args: [{
                selector: 'hrb-circle-button-with-label',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['as', 'disabled', 'href', 'icon', 'pAriaLabel', 'pAriaLabelledby', 'pAriaRole', 'rel', 'target', 'theme', 'type'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var HrbCircled = /** @class */ (function () {
    function HrbCircled(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    HrbCircled.ɵfac = function HrbCircled_Factory(t) { return new (t || HrbCircled)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    HrbCircled.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HrbCircled, selectors: [["hrb-circled"]], inputs: { size: "size", theme: "theme" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function HrbCircled_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    HrbCircled = __decorate([
        ProxyCmp({
            inputs: ['size', 'theme']
        })
    ], HrbCircled);
    return HrbCircled;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HrbCircled, [{
        type: Component,
        args: [{
                selector: 'hrb-circled',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['size', 'theme'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var HrbColorsGlobal = /** @class */ (function () {
    function HrbColorsGlobal(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    HrbColorsGlobal.ɵfac = function HrbColorsGlobal_Factory(t) { return new (t || HrbColorsGlobal)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    HrbColorsGlobal.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HrbColorsGlobal, selectors: [["hrb-colors-global"]], ngContentSelectors: _c0, decls: 1, vars: 0, template: function HrbColorsGlobal_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    HrbColorsGlobal = __decorate([
        ProxyCmp({})
    ], HrbColorsGlobal);
    return HrbColorsGlobal;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HrbColorsGlobal, [{
        type: Component,
        args: [{
                selector: 'hrb-colors-global',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: [],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var HrbContainer = /** @class */ (function () {
    function HrbContainer(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['swipeUp', 'swipeRight', 'swipeDown', 'swipeLeft']);
    }
    HrbContainer.ɵfac = function HrbContainer_Factory(t) { return new (t || HrbContainer)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    HrbContainer.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HrbContainer, selectors: [["hrb-container"]], inputs: { dataVariant: "dataVariant" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function HrbContainer_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    HrbContainer = __decorate([
        ProxyCmp({
            inputs: ['dataVariant']
        })
    ], HrbContainer);
    return HrbContainer;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HrbContainer, [{
        type: Component,
        args: [{
                selector: 'hrb-container',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['dataVariant'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var HrbContentSection = /** @class */ (function () {
    function HrbContentSection(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    HrbContentSection.ɵfac = function HrbContentSection_Factory(t) { return new (t || HrbContentSection)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    HrbContentSection.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HrbContentSection, selectors: [["hrb-content-section"]], ngContentSelectors: _c0, decls: 1, vars: 0, template: function HrbContentSection_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    HrbContentSection = __decorate([
        ProxyCmp({})
    ], HrbContentSection);
    return HrbContentSection;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HrbContentSection, [{
        type: Component,
        args: [{
                selector: 'hrb-content-section',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: [],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var HrbDataItem = /** @class */ (function () {
    function HrbDataItem(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    HrbDataItem.ɵfac = function HrbDataItem_Factory(t) { return new (t || HrbDataItem)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    HrbDataItem.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HrbDataItem, selectors: [["hrb-data-item"]], inputs: { as: "as", data: "data", def: "def", disabled: "disabled", href: "href", icon: "icon", label: "label", metadata: "metadata", note: "note", pAriaLabel: "pAriaLabel", pAriaLabelledby: "pAriaLabelledby", pAriaRole: "pAriaRole", rel: "rel", target: "target", term: "term", thumbAlt: "thumbAlt", thumbSrc: "thumbSrc", type: "type" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function HrbDataItem_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    HrbDataItem = __decorate([
        ProxyCmp({
            inputs: ['as', 'data', 'def', 'disabled', 'href', 'icon', 'label', 'metadata', 'note', 'pAriaLabel', 'pAriaLabelledby', 'pAriaRole', 'rel', 'target', 'term', 'thumbAlt', 'thumbSrc', 'type']
        })
    ], HrbDataItem);
    return HrbDataItem;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HrbDataItem, [{
        type: Component,
        args: [{
                selector: 'hrb-data-item',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['as', 'data', 'def', 'disabled', 'href', 'icon', 'label', 'metadata', 'note', 'pAriaLabel', 'pAriaLabelledby', 'pAriaRole', 'rel', 'target', 'term', 'thumbAlt', 'thumbSrc', 'type'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var HrbDataList = /** @class */ (function () {
    function HrbDataList(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    HrbDataList.ɵfac = function HrbDataList_Factory(t) { return new (t || HrbDataList)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    HrbDataList.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HrbDataList, selectors: [["hrb-data-list"]], inputs: { theme: "theme" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function HrbDataList_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    HrbDataList = __decorate([
        ProxyCmp({
            inputs: ['theme']
        })
    ], HrbDataList);
    return HrbDataList;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HrbDataList, [{
        type: Component,
        args: [{
                selector: 'hrb-data-list',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['theme'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var HrbDot = /** @class */ (function () {
    function HrbDot(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['optionSelected']);
    }
    HrbDot.ɵfac = function HrbDot_Factory(t) { return new (t || HrbDot)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    HrbDot.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HrbDot, selectors: [["hrb-dot"]], inputs: { active: "active", index: "index", pAriaLabel: "pAriaLabel", pAriaPressed: "pAriaPressed" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function HrbDot_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    HrbDot = __decorate([
        ProxyCmp({
            inputs: ['active', 'index', 'pAriaLabel', 'pAriaPressed']
        })
    ], HrbDot);
    return HrbDot;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HrbDot, [{
        type: Component,
        args: [{
                selector: 'hrb-dot',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['active', 'index', 'pAriaLabel', 'pAriaPressed'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var HrbDotNav = /** @class */ (function () {
    function HrbDotNav(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    HrbDotNav.ɵfac = function HrbDotNav_Factory(t) { return new (t || HrbDotNav)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    HrbDotNav.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HrbDotNav, selectors: [["hrb-dot-nav"]], inputs: { pAriaLabel: "pAriaLabel" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function HrbDotNav_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    HrbDotNav = __decorate([
        ProxyCmp({
            inputs: ['pAriaLabel']
        })
    ], HrbDotNav);
    return HrbDotNav;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HrbDotNav, [{
        type: Component,
        args: [{
                selector: 'hrb-dot-nav',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['pAriaLabel'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var HrbDrawer = /** @class */ (function () {
    function HrbDrawer(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['drawerToggled']);
    }
    HrbDrawer.ɵfac = function HrbDrawer_Factory(t) { return new (t || HrbDrawer)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    HrbDrawer.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HrbDrawer, selectors: [["hrb-drawer"]], inputs: { expandedOnLoad: "expandedOnLoad", showTrigger: "showTrigger" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function HrbDrawer_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    HrbDrawer = __decorate([
        ProxyCmp({
            inputs: ['expandedOnLoad', 'showTrigger'],
            methods: ['toggleDrawer']
        })
    ], HrbDrawer);
    return HrbDrawer;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HrbDrawer, [{
        type: Component,
        args: [{
                selector: 'hrb-drawer',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['expandedOnLoad', 'showTrigger'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var HrbDropdownMenu = /** @class */ (function () {
    function HrbDropdownMenu(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['hrbOpen', 'hrbClose']);
    }
    HrbDropdownMenu.ɵfac = function HrbDropdownMenu_Factory(t) { return new (t || HrbDropdownMenu)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    HrbDropdownMenu.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HrbDropdownMenu, selectors: [["hrb-dropdown-menu"]], inputs: { multiselect: "multiselect", triggerValue: "triggerValue" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function HrbDropdownMenu_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    HrbDropdownMenu = __decorate([
        ProxyCmp({
            inputs: ['multiselect', 'triggerValue']
        })
    ], HrbDropdownMenu);
    return HrbDropdownMenu;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HrbDropdownMenu, [{
        type: Component,
        args: [{
                selector: 'hrb-dropdown-menu',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['multiselect', 'triggerValue'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var HrbDropdownMenuItem = /** @class */ (function () {
    function HrbDropdownMenuItem(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['menuItemClicked']);
    }
    HrbDropdownMenuItem.ɵfac = function HrbDropdownMenuItem_Factory(t) { return new (t || HrbDropdownMenuItem)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    HrbDropdownMenuItem.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HrbDropdownMenuItem, selectors: [["hrb-dropdown-menu-item"]], inputs: { elementId: "elementId", name: "name", type: "type", value: "value" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function HrbDropdownMenuItem_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    HrbDropdownMenuItem = __decorate([
        ProxyCmp({
            inputs: ['elementId', 'name', 'type', 'value']
        })
    ], HrbDropdownMenuItem);
    return HrbDropdownMenuItem;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HrbDropdownMenuItem, [{
        type: Component,
        args: [{
                selector: 'hrb-dropdown-menu-item',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['elementId', 'name', 'type', 'value'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var HrbExpandCollapse = /** @class */ (function () {
    function HrbExpandCollapse(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['expandCollapsedToggle']);
    }
    HrbExpandCollapse.ɵfac = function HrbExpandCollapse_Factory(t) { return new (t || HrbExpandCollapse)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    HrbExpandCollapse.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HrbExpandCollapse, selectors: [["hrb-expand-collapse"]], inputs: { autoIdentifier: "autoIdentifier", label: "label" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function HrbExpandCollapse_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    HrbExpandCollapse = __decorate([
        ProxyCmp({
            inputs: ['autoIdentifier', 'label'],
            methods: ['toggleEl']
        })
    ], HrbExpandCollapse);
    return HrbExpandCollapse;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HrbExpandCollapse, [{
        type: Component,
        args: [{
                selector: 'hrb-expand-collapse',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['autoIdentifier', 'label'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var HrbFlexCol = /** @class */ (function () {
    function HrbFlexCol(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    HrbFlexCol.ɵfac = function HrbFlexCol_Factory(t) { return new (t || HrbFlexCol)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    HrbFlexCol.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HrbFlexCol, selectors: [["hrb-flex-col"]], inputs: { col: "col", colL: "colL", colM: "colM", colS: "colS", isCentered: "isCentered", offsetL: "offsetL", offsetM: "offsetM", offsetS: "offsetS" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function HrbFlexCol_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    HrbFlexCol = __decorate([
        ProxyCmp({
            inputs: ['col', 'colL', 'colM', 'colS', 'isCentered', 'offsetL', 'offsetM', 'offsetS']
        })
    ], HrbFlexCol);
    return HrbFlexCol;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HrbFlexCol, [{
        type: Component,
        args: [{
                selector: 'hrb-flex-col',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['col', 'colL', 'colM', 'colS', 'isCentered', 'offsetL', 'offsetM', 'offsetS'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var HrbFlexContainer = /** @class */ (function () {
    function HrbFlexContainer(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    HrbFlexContainer.ɵfac = function HrbFlexContainer_Factory(t) { return new (t || HrbFlexContainer)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    HrbFlexContainer.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HrbFlexContainer, selectors: [["hrb-flex-container"]], inputs: { pAriaLabel: "pAriaLabel" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function HrbFlexContainer_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    HrbFlexContainer = __decorate([
        ProxyCmp({
            inputs: ['pAriaLabel']
        })
    ], HrbFlexContainer);
    return HrbFlexContainer;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HrbFlexContainer, [{
        type: Component,
        args: [{
                selector: 'hrb-flex-container',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['pAriaLabel'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var HrbFlexGhost = /** @class */ (function () {
    function HrbFlexGhost(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    HrbFlexGhost.ɵfac = function HrbFlexGhost_Factory(t) { return new (t || HrbFlexGhost)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    HrbFlexGhost.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HrbFlexGhost, selectors: [["hrb-flex-ghost"]], inputs: { pAriaHidden: "pAriaHidden" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function HrbFlexGhost_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    HrbFlexGhost = __decorate([
        ProxyCmp({
            inputs: ['pAriaHidden']
        })
    ], HrbFlexGhost);
    return HrbFlexGhost;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HrbFlexGhost, [{
        type: Component,
        args: [{
                selector: 'hrb-flex-ghost',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['pAriaHidden'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var HrbFlexRow = /** @class */ (function () {
    function HrbFlexRow(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    HrbFlexRow.ɵfac = function HrbFlexRow_Factory(t) { return new (t || HrbFlexRow)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    HrbFlexRow.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HrbFlexRow, selectors: [["hrb-flex-row"]], inputs: { alignItems: "alignItems", isCentered: "isCentered", isReversed: "isReversed", justifyContent: "justifyContent" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function HrbFlexRow_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    HrbFlexRow = __decorate([
        ProxyCmp({
            inputs: ['alignItems', 'isCentered', 'isReversed', 'justifyContent']
        })
    ], HrbFlexRow);
    return HrbFlexRow;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HrbFlexRow, [{
        type: Component,
        args: [{
                selector: 'hrb-flex-row',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['alignItems', 'isCentered', 'isReversed', 'justifyContent'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var HrbFontsGlobal = /** @class */ (function () {
    function HrbFontsGlobal(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    HrbFontsGlobal.ɵfac = function HrbFontsGlobal_Factory(t) { return new (t || HrbFontsGlobal)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    HrbFontsGlobal.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HrbFontsGlobal, selectors: [["hrb-fonts-global"]], ngContentSelectors: _c0, decls: 1, vars: 0, template: function HrbFontsGlobal_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    HrbFontsGlobal = __decorate([
        ProxyCmp({})
    ], HrbFontsGlobal);
    return HrbFontsGlobal;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HrbFontsGlobal, [{
        type: Component,
        args: [{
                selector: 'hrb-fonts-global',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: [],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var HrbFooter = /** @class */ (function () {
    function HrbFooter(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    HrbFooter.ɵfac = function HrbFooter_Factory(t) { return new (t || HrbFooter)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    HrbFooter.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HrbFooter, selectors: [["hrb-footer"]], inputs: { dataInput: "dataInput", theme: "theme" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function HrbFooter_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    HrbFooter = __decorate([
        ProxyCmp({
            inputs: ['dataInput', 'theme']
        })
    ], HrbFooter);
    return HrbFooter;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HrbFooter, [{
        type: Component,
        args: [{
                selector: 'hrb-footer',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['dataInput', 'theme'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var HrbFooterSection = /** @class */ (function () {
    function HrbFooterSection(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    HrbFooterSection.ɵfac = function HrbFooterSection_Factory(t) { return new (t || HrbFooterSection)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    HrbFooterSection.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HrbFooterSection, selectors: [["hrb-footer-section"]], ngContentSelectors: _c0, decls: 1, vars: 0, template: function HrbFooterSection_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    HrbFooterSection = __decorate([
        ProxyCmp({})
    ], HrbFooterSection);
    return HrbFooterSection;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HrbFooterSection, [{
        type: Component,
        args: [{
                selector: 'hrb-footer-section',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: [],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var HrbGlobal = /** @class */ (function () {
    function HrbGlobal(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    HrbGlobal.ɵfac = function HrbGlobal_Factory(t) { return new (t || HrbGlobal)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    HrbGlobal.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HrbGlobal, selectors: [["hrb-global"]], inputs: { animation: "animation", bdsColors: "bdsColors", bdsEffects: "bdsEffects", bdsFlex: "bdsFlex", bdsGrids: "bdsGrids", bdsSpacing: "bdsSpacing", bdsText: "bdsText", colors: "colors", dataTheme: "dataTheme", fonts: "fonts", reset: "reset", spacing: "spacing", storytellingIcons: "storytellingIcons", typography: "typography", utility: "utility" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function HrbGlobal_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    HrbGlobal = __decorate([
        ProxyCmp({
            inputs: ['animation', 'bdsColors', 'bdsEffects', 'bdsFlex', 'bdsGrids', 'bdsSpacing', 'bdsText', 'colors', 'dataTheme', 'fonts', 'reset', 'spacing', 'storytellingIcons', 'typography', 'utility']
        })
    ], HrbGlobal);
    return HrbGlobal;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HrbGlobal, [{
        type: Component,
        args: [{
                selector: 'hrb-global',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['animation', 'bdsColors', 'bdsEffects', 'bdsFlex', 'bdsGrids', 'bdsSpacing', 'bdsText', 'colors', 'dataTheme', 'fonts', 'reset', 'spacing', 'storytellingIcons', 'typography', 'utility'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var HrbGridCol = /** @class */ (function () {
    function HrbGridCol(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    HrbGridCol.ɵfac = function HrbGridCol_Factory(t) { return new (t || HrbGridCol)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    HrbGridCol.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HrbGridCol, selectors: [["hrb-grid-col"]], inputs: { colSpan: "colSpan", colSpanL: "colSpanL", colSpanM: "colSpanM", colSpanS: "colSpanS", isGrid: "isGrid", row: "row", rowL: "rowL", rowM: "rowM", rowS: "rowS" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function HrbGridCol_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    HrbGridCol = __decorate([
        ProxyCmp({
            inputs: ['colSpan', 'colSpanL', 'colSpanM', 'colSpanS', 'isGrid', 'row', 'rowL', 'rowM', 'rowS']
        })
    ], HrbGridCol);
    return HrbGridCol;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HrbGridCol, [{
        type: Component,
        args: [{
                selector: 'hrb-grid-col',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['colSpan', 'colSpanL', 'colSpanM', 'colSpanS', 'isGrid', 'row', 'rowL', 'rowM', 'rowS'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var HrbGridGhost = /** @class */ (function () {
    function HrbGridGhost(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    HrbGridGhost.ɵfac = function HrbGridGhost_Factory(t) { return new (t || HrbGridGhost)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    HrbGridGhost.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HrbGridGhost, selectors: [["hrb-grid-ghost"]], inputs: { pAriaHidden: "pAriaHidden" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function HrbGridGhost_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    HrbGridGhost = __decorate([
        ProxyCmp({
            inputs: ['pAriaHidden']
        })
    ], HrbGridGhost);
    return HrbGridGhost;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HrbGridGhost, [{
        type: Component,
        args: [{
                selector: 'hrb-grid-ghost',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['pAriaHidden'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var HrbGridRow = /** @class */ (function () {
    function HrbGridRow(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    HrbGridRow.ɵfac = function HrbGridRow_Factory(t) { return new (t || HrbGridRow)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    HrbGridRow.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HrbGridRow, selectors: [["hrb-grid-row"]], inputs: { theme: "theme" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function HrbGridRow_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    HrbGridRow = __decorate([
        ProxyCmp({
            inputs: ['theme']
        })
    ], HrbGridRow);
    return HrbGridRow;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HrbGridRow, [{
        type: Component,
        args: [{
                selector: 'hrb-grid-row',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['theme'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var HrbHrbbrandGlobal = /** @class */ (function () {
    function HrbHrbbrandGlobal(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    HrbHrbbrandGlobal.ɵfac = function HrbHrbbrandGlobal_Factory(t) { return new (t || HrbHrbbrandGlobal)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    HrbHrbbrandGlobal.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HrbHrbbrandGlobal, selectors: [["hrb-hrbbrand-global"]], ngContentSelectors: _c0, decls: 1, vars: 0, template: function HrbHrbbrandGlobal_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    HrbHrbbrandGlobal = __decorate([
        ProxyCmp({})
    ], HrbHrbbrandGlobal);
    return HrbHrbbrandGlobal;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HrbHrbbrandGlobal, [{
        type: Component,
        args: [{
                selector: 'hrb-hrbbrand-global',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: [],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var HrbIcon = /** @class */ (function () {
    function HrbIcon(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    HrbIcon.ɵfac = function HrbIcon_Factory(t) { return new (t || HrbIcon)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    HrbIcon.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HrbIcon, selectors: [["hrb-icon"]], inputs: { dataSize: "dataSize", name: "name", theme: "theme" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function HrbIcon_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    HrbIcon = __decorate([
        ProxyCmp({
            inputs: ['dataSize', 'name', 'theme']
        })
    ], HrbIcon);
    return HrbIcon;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HrbIcon, [{
        type: Component,
        args: [{
                selector: 'hrb-icon',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['dataSize', 'name', 'theme'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var HrbIllustration = /** @class */ (function () {
    function HrbIllustration(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    HrbIllustration.ɵfac = function HrbIllustration_Factory(t) { return new (t || HrbIllustration)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    HrbIllustration.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HrbIllustration, selectors: [["hrb-illustration"]], inputs: { alt: "alt", dataName: "dataName", height: "height", loading: "loading", width: "width" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function HrbIllustration_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    HrbIllustration = __decorate([
        ProxyCmp({
            inputs: ['alt', 'dataName', 'height', 'loading', 'width']
        })
    ], HrbIllustration);
    return HrbIllustration;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HrbIllustration, [{
        type: Component,
        args: [{
                selector: 'hrb-illustration',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['alt', 'dataName', 'height', 'loading', 'width'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var HrbImg = /** @class */ (function () {
    function HrbImg(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['hrbImgWillLoad', 'hrbImgDidLoad', 'hrbError']);
    }
    HrbImg.ɵfac = function HrbImg_Factory(t) { return new (t || HrbImg)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    HrbImg.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HrbImg, selectors: [["hrb-img"]], inputs: { alt: "alt", fit: "fit", height: "height", pLoading: "pLoading", src: "src", srcset: "srcset", width: "width" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function HrbImg_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    HrbImg = __decorate([
        ProxyCmp({
            inputs: ['alt', 'fit', 'height', 'pLoading', 'src', 'srcset', 'width']
        })
    ], HrbImg);
    return HrbImg;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HrbImg, [{
        type: Component,
        args: [{
                selector: 'hrb-img',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['alt', 'fit', 'height', 'pLoading', 'src', 'srcset', 'width'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var HrbInlineAlert = /** @class */ (function () {
    function HrbInlineAlert(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['alertClosed', 'alertOpen']);
    }
    HrbInlineAlert.ɵfac = function HrbInlineAlert_Factory(t) { return new (t || HrbInlineAlert)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    HrbInlineAlert.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HrbInlineAlert, selectors: [["hrb-inline-alert"]], inputs: { autoIdentifier: "autoIdentifier", headerTitle: "headerTitle", theme: "theme", variant: "variant" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function HrbInlineAlert_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    HrbInlineAlert = __decorate([
        ProxyCmp({
            inputs: ['autoIdentifier', 'headerTitle', 'theme', 'variant'],
            methods: ['closeAlert']
        })
    ], HrbInlineAlert);
    return HrbInlineAlert;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HrbInlineAlert, [{
        type: Component,
        args: [{
                selector: 'hrb-inline-alert',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['autoIdentifier', 'headerTitle', 'theme', 'variant'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var HrbInput = /** @class */ (function () {
    function HrbInput(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['hrbBlur', 'hrbChange', 'hrbFocus', 'hrbInput', 'iconButtonClicked']);
    }
    HrbInput.ɵfac = function HrbInput_Factory(t) { return new (t || HrbInput)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    HrbInput.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HrbInput, selectors: [["hrb-input"]], inputs: { accept: "accept", allowPasswordToggle: "allowPasswordToggle", autoIdentifier: "autoIdentifier", autocomplete: "autocomplete", capture: "capture", copyPaste: "copyPaste", dirname: "dirname", disabled: "disabled", errorLabel: "errorLabel", forceIconVisibility: "forceIconVisibility", form: "form", formaction: "formaction", formenctype: "formenctype", formmethod: "formmethod", formnovalidate: "formnovalidate", hasError: "hasError", helperText: "helperText", icon: "icon", iconButton: "iconButton", inputId: "inputId", inputmode: "inputmode", label: "label", list: "list", loading: "loading", maskPattern: "maskPattern", maxValue: "maxValue", maxlength: "maxlength", minValue: "minValue", minlength: "minlength", multiple: "multiple", name: "name", originalValue: "originalValue", pActivedescendant: "pActivedescendant", pAriaAutocomplete: "pAriaAutocomplete", pAriaMultiline: "pAriaMultiline", pAriaOwns: "pAriaOwns", pattern: "pattern", placeholder: "placeholder", readonly: "readonly", required: "required", step: "step", type: "type", value: "value" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function HrbInput_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    HrbInput = __decorate([
        ProxyCmp({
            inputs: ['accept', 'allowPasswordToggle', 'autoIdentifier', 'autocomplete', 'capture', 'copyPaste', 'dirname', 'disabled', 'errorLabel', 'forceIconVisibility', 'form', 'formaction', 'formenctype', 'formmethod', 'formnovalidate', 'hasError', 'helperText', 'icon', 'iconButton', 'inputId', 'inputmode', 'label', 'list', 'loading', 'maskPattern', 'maxValue', 'maxlength', 'minValue', 'minlength', 'multiple', 'name', 'originalValue', 'pActivedescendant', 'pAriaAutocomplete', 'pAriaMultiline', 'pAriaOwns', 'pattern', 'placeholder', 'readonly', 'required', 'step', 'type', 'value'],
            methods: ['getElement', 'setFocus']
        })
    ], HrbInput);
    return HrbInput;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HrbInput, [{
        type: Component,
        args: [{
                selector: 'hrb-input',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['accept', 'allowPasswordToggle', 'autoIdentifier', 'autocomplete', 'capture', 'copyPaste', 'dirname', 'disabled', 'errorLabel', 'forceIconVisibility', 'form', 'formaction', 'formenctype', 'formmethod', 'formnovalidate', 'hasError', 'helperText', 'icon', 'iconButton', 'inputId', 'inputmode', 'label', 'list', 'loading', 'maskPattern', 'maxValue', 'maxlength', 'minValue', 'minlength', 'multiple', 'name', 'originalValue', 'pActivedescendant', 'pAriaAutocomplete', 'pAriaMultiline', 'pAriaOwns', 'pattern', 'placeholder', 'readonly', 'required', 'step', 'type', 'value'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var HrbInputGroup = /** @class */ (function () {
    function HrbInputGroup(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['inputGroupClicked']);
    }
    HrbInputGroup.ɵfac = function HrbInputGroup_Factory(t) { return new (t || HrbInputGroup)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    HrbInputGroup.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HrbInputGroup, selectors: [["hrb-input-group"]], inputs: { accept: "accept", allowPasswordToggle: "allowPasswordToggle", autoIdentifier: "autoIdentifier", autocomplete: "autocomplete", capture: "capture", copyPaste: "copyPaste", dataButtonIcon: "dataButtonIcon", dataInputErrorLabel: "dataInputErrorLabel", dataInputHasError: "dataInputHasError", dataInputHelperText: "dataInputHelperText", dataInputLabel: "dataInputLabel", dataInputLoading: "dataInputLoading", dataInputType: "dataInputType", dirname: "dirname", disabled: "disabled", forceIconVisibility: "forceIconVisibility", form: "form", formaction: "formaction", formenctype: "formenctype", formmethod: "formmethod", formnovalidate: "formnovalidate", icon: "icon", inputmode: "inputmode", list: "list", maskPattern: "maskPattern", maxValue: "maxValue", maxlength: "maxlength", minValue: "minValue", minlength: "minlength", multiple: "multiple", name: "name", originalValue: "originalValue", pActivedescendant: "pActivedescendant", pAriaAutocomplete: "pAriaAutocomplete", pAriaMultiline: "pAriaMultiline", pAriaOwns: "pAriaOwns", pattern: "pattern", placeholder: "placeholder", readonly: "readonly", required: "required", step: "step", type: "type", value: "value" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function HrbInputGroup_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    HrbInputGroup = __decorate([
        ProxyCmp({
            inputs: ['accept', 'allowPasswordToggle', 'autoIdentifier', 'autocomplete', 'capture', 'copyPaste', 'dataButtonIcon', 'dataInputErrorLabel', 'dataInputHasError', 'dataInputHelperText', 'dataInputLabel', 'dataInputLoading', 'dataInputType', 'dirname', 'disabled', 'forceIconVisibility', 'form', 'formaction', 'formenctype', 'formmethod', 'formnovalidate', 'icon', 'inputmode', 'list', 'maskPattern', 'maxValue', 'maxlength', 'minValue', 'minlength', 'multiple', 'name', 'originalValue', 'pActivedescendant', 'pAriaAutocomplete', 'pAriaMultiline', 'pAriaOwns', 'pattern', 'placeholder', 'readonly', 'required', 'step', 'type', 'value']
        })
    ], HrbInputGroup);
    return HrbInputGroup;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HrbInputGroup, [{
        type: Component,
        args: [{
                selector: 'hrb-input-group',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['accept', 'allowPasswordToggle', 'autoIdentifier', 'autocomplete', 'capture', 'copyPaste', 'dataButtonIcon', 'dataInputErrorLabel', 'dataInputHasError', 'dataInputHelperText', 'dataInputLabel', 'dataInputLoading', 'dataInputType', 'dirname', 'disabled', 'forceIconVisibility', 'form', 'formaction', 'formenctype', 'formmethod', 'formnovalidate', 'icon', 'inputmode', 'list', 'maskPattern', 'maxValue', 'maxlength', 'minValue', 'minlength', 'multiple', 'name', 'originalValue', 'pActivedescendant', 'pAriaAutocomplete', 'pAriaMultiline', 'pAriaOwns', 'pattern', 'placeholder', 'readonly', 'required', 'step', 'type', 'value'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var HrbInterstitial = /** @class */ (function () {
    function HrbInterstitial(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    HrbInterstitial.ɵfac = function HrbInterstitial_Factory(t) { return new (t || HrbInterstitial)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    HrbInterstitial.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HrbInterstitial, selectors: [["hrb-interstitial"]], inputs: { dataVariant: "dataVariant" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function HrbInterstitial_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    HrbInterstitial = __decorate([
        ProxyCmp({
            inputs: ['dataVariant']
        })
    ], HrbInterstitial);
    return HrbInterstitial;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HrbInterstitial, [{
        type: Component,
        args: [{
                selector: 'hrb-interstitial',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['dataVariant'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var HrbInterstitialActions = /** @class */ (function () {
    function HrbInterstitialActions(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    HrbInterstitialActions.ɵfac = function HrbInterstitialActions_Factory(t) { return new (t || HrbInterstitialActions)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    HrbInterstitialActions.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HrbInterstitialActions, selectors: [["hrb-interstitial-actions"]], ngContentSelectors: _c0, decls: 1, vars: 0, template: function HrbInterstitialActions_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    HrbInterstitialActions = __decorate([
        ProxyCmp({})
    ], HrbInterstitialActions);
    return HrbInterstitialActions;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HrbInterstitialActions, [{
        type: Component,
        args: [{
                selector: 'hrb-interstitial-actions',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: [],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var HrbInterstitialImage = /** @class */ (function () {
    function HrbInterstitialImage(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    HrbInterstitialImage.ɵfac = function HrbInterstitialImage_Factory(t) { return new (t || HrbInterstitialImage)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    HrbInterstitialImage.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HrbInterstitialImage, selectors: [["hrb-interstitial-image"]], ngContentSelectors: _c0, decls: 1, vars: 0, template: function HrbInterstitialImage_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    HrbInterstitialImage = __decorate([
        ProxyCmp({})
    ], HrbInterstitialImage);
    return HrbInterstitialImage;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HrbInterstitialImage, [{
        type: Component,
        args: [{
                selector: 'hrb-interstitial-image',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: [],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var HrbInterstitialSubtitle = /** @class */ (function () {
    function HrbInterstitialSubtitle(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    HrbInterstitialSubtitle.ɵfac = function HrbInterstitialSubtitle_Factory(t) { return new (t || HrbInterstitialSubtitle)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    HrbInterstitialSubtitle.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HrbInterstitialSubtitle, selectors: [["hrb-interstitial-subtitle"]], ngContentSelectors: _c0, decls: 1, vars: 0, template: function HrbInterstitialSubtitle_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    HrbInterstitialSubtitle = __decorate([
        ProxyCmp({})
    ], HrbInterstitialSubtitle);
    return HrbInterstitialSubtitle;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HrbInterstitialSubtitle, [{
        type: Component,
        args: [{
                selector: 'hrb-interstitial-subtitle',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: [],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var HrbInterstitialTitle = /** @class */ (function () {
    function HrbInterstitialTitle(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    HrbInterstitialTitle.ɵfac = function HrbInterstitialTitle_Factory(t) { return new (t || HrbInterstitialTitle)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    HrbInterstitialTitle.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HrbInterstitialTitle, selectors: [["hrb-interstitial-title"]], ngContentSelectors: _c0, decls: 1, vars: 0, template: function HrbInterstitialTitle_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    HrbInterstitialTitle = __decorate([
        ProxyCmp({})
    ], HrbInterstitialTitle);
    return HrbInterstitialTitle;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HrbInterstitialTitle, [{
        type: Component,
        args: [{
                selector: 'hrb-interstitial-title',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: [],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var HrbLabel = /** @class */ (function () {
    function HrbLabel(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    HrbLabel.ɵfac = function HrbLabel_Factory(t) { return new (t || HrbLabel)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    HrbLabel.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HrbLabel, selectors: [["hrb-label"]], inputs: { as: "as", autoIdentifier: "autoIdentifier", disabled: "disabled", href: "href", icon: "icon", pAriaLabel: "pAriaLabel", pAriaLabelledby: "pAriaLabelledby", pAriaRole: "pAriaRole", rel: "rel", target: "target", theme: "theme", type: "type" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function HrbLabel_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    HrbLabel = __decorate([
        ProxyCmp({
            inputs: ['as', 'autoIdentifier', 'disabled', 'href', 'icon', 'pAriaLabel', 'pAriaLabelledby', 'pAriaRole', 'rel', 'target', 'theme', 'type']
        })
    ], HrbLabel);
    return HrbLabel;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HrbLabel, [{
        type: Component,
        args: [{
                selector: 'hrb-label',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['as', 'autoIdentifier', 'disabled', 'href', 'icon', 'pAriaLabel', 'pAriaLabelledby', 'pAriaRole', 'rel', 'target', 'theme', 'type'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var HrbLayout = /** @class */ (function () {
    function HrbLayout(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    HrbLayout.ɵfac = function HrbLayout_Factory(t) { return new (t || HrbLayout)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    HrbLayout.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HrbLayout, selectors: [["hrb-layout"]], inputs: { alignItems: "alignItems", hasTransition: "hasTransition", isFlush: "isFlush", isGapless: "isGapless", justifyContent: "justifyContent", layout: "layout", layoutLarge: "layoutLarge", layoutMedium: "layoutMedium", layoutSmall: "layoutSmall" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function HrbLayout_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    HrbLayout = __decorate([
        ProxyCmp({
            inputs: ['alignItems', 'hasTransition', 'isFlush', 'isGapless', 'justifyContent', 'layout', 'layoutLarge', 'layoutMedium', 'layoutSmall']
        })
    ], HrbLayout);
    return HrbLayout;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HrbLayout, [{
        type: Component,
        args: [{
                selector: 'hrb-layout',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['alignItems', 'hasTransition', 'isFlush', 'isGapless', 'justifyContent', 'layout', 'layoutLarge', 'layoutMedium', 'layoutSmall'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var HrbLegalSection = /** @class */ (function () {
    function HrbLegalSection(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    HrbLegalSection.ɵfac = function HrbLegalSection_Factory(t) { return new (t || HrbLegalSection)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    HrbLegalSection.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HrbLegalSection, selectors: [["hrb-legal-section"]], ngContentSelectors: _c0, decls: 1, vars: 0, template: function HrbLegalSection_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    HrbLegalSection = __decorate([
        ProxyCmp({})
    ], HrbLegalSection);
    return HrbLegalSection;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HrbLegalSection, [{
        type: Component,
        args: [{
                selector: 'hrb-legal-section',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: [],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var HrbLink = /** @class */ (function () {
    function HrbLink(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    HrbLink.ɵfac = function HrbLink_Factory(t) { return new (t || HrbLink)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    HrbLink.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HrbLink, selectors: [["hrb-link"]], inputs: { as: "as", autoIdentifier: "autoIdentifier", disabled: "disabled", href: "href", icon: "icon", iconPosition: "iconPosition", pAriaLabel: "pAriaLabel", pAriaLabelledby: "pAriaLabelledby", pAriaRole: "pAriaRole", rel: "rel", target: "target", theme: "theme", type: "type", underline: "underline" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function HrbLink_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    HrbLink = __decorate([
        ProxyCmp({
            inputs: ['as', 'autoIdentifier', 'disabled', 'href', 'icon', 'iconPosition', 'pAriaLabel', 'pAriaLabelledby', 'pAriaRole', 'rel', 'target', 'theme', 'type', 'underline']
        })
    ], HrbLink);
    return HrbLink;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HrbLink, [{
        type: Component,
        args: [{
                selector: 'hrb-link',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['as', 'autoIdentifier', 'disabled', 'href', 'icon', 'iconPosition', 'pAriaLabel', 'pAriaLabelledby', 'pAriaRole', 'rel', 'target', 'theme', 'type', 'underline'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var HrbListButton = /** @class */ (function () {
    function HrbListButton(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    HrbListButton.ɵfac = function HrbListButton_Factory(t) { return new (t || HrbListButton)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    HrbListButton.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HrbListButton, selectors: [["hrb-list-button"]], inputs: { as: "as", circled: "circled", disabled: "disabled", href: "href", icon: "icon", iconPosition: "iconPosition", metadata: "metadata", outlined: "outlined", pAriaLabel: "pAriaLabel", pAriaLabelledby: "pAriaLabelledby", pAriaRole: "pAriaRole", rel: "rel", target: "target", theme: "theme", type: "type" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function HrbListButton_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    HrbListButton = __decorate([
        ProxyCmp({
            inputs: ['as', 'circled', 'disabled', 'href', 'icon', 'iconPosition', 'metadata', 'outlined', 'pAriaLabel', 'pAriaLabelledby', 'pAriaRole', 'rel', 'target', 'theme', 'type']
        })
    ], HrbListButton);
    return HrbListButton;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HrbListButton, [{
        type: Component,
        args: [{
                selector: 'hrb-list-button',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['as', 'circled', 'disabled', 'href', 'icon', 'iconPosition', 'metadata', 'outlined', 'pAriaLabel', 'pAriaLabelledby', 'pAriaRole', 'rel', 'target', 'theme', 'type'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var HrbLoader = /** @class */ (function () {
    function HrbLoader(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    HrbLoader.ɵfac = function HrbLoader_Factory(t) { return new (t || HrbLoader)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    HrbLoader.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HrbLoader, selectors: [["hrb-loader"]], inputs: { theme: "theme" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function HrbLoader_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    HrbLoader = __decorate([
        ProxyCmp({
            inputs: ['theme']
        })
    ], HrbLoader);
    return HrbLoader;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HrbLoader, [{
        type: Component,
        args: [{
                selector: 'hrb-loader',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['theme'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var HrbModal = /** @class */ (function () {
    function HrbModal(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['swipeUp', 'swipeRight', 'swipeDown', 'swipeLeft', 'hrbClose', 'hrbOpen']);
    }
    HrbModal.ɵfac = function HrbModal_Factory(t) { return new (t || HrbModal)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    HrbModal.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HrbModal, selectors: [["hrb-modal"]], inputs: { disableBackground: "disableBackground", modalId: "modalId", modalTitle: "modalTitle", size: "size", theme: "theme", type: "type", variant: "variant" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function HrbModal_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    HrbModal = __decorate([
        ProxyCmp({
            inputs: ['disableBackground', 'modalId', 'modalTitle', 'size', 'theme', 'type', 'variant'],
            methods: ['close', 'show']
        })
    ], HrbModal);
    return HrbModal;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HrbModal, [{
        type: Component,
        args: [{
                selector: 'hrb-modal',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['disableBackground', 'modalId', 'modalTitle', 'size', 'theme', 'type', 'variant'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var HrbNavBar = /** @class */ (function () {
    function HrbNavBar(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    HrbNavBar.ɵfac = function HrbNavBar_Factory(t) { return new (t || HrbNavBar)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    HrbNavBar.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HrbNavBar, selectors: [["hrb-nav-bar"]], inputs: { currentMobileMenuIcon: "currentMobileMenuIcon" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function HrbNavBar_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    HrbNavBar = __decorate([
        ProxyCmp({
            inputs: ['currentMobileMenuIcon']
        })
    ], HrbNavBar);
    return HrbNavBar;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HrbNavBar, [{
        type: Component,
        args: [{
                selector: 'hrb-nav-bar',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['currentMobileMenuIcon'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var HrbNavLink = /** @class */ (function () {
    function HrbNavLink(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    HrbNavLink.ɵfac = function HrbNavLink_Factory(t) { return new (t || HrbNavLink)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    HrbNavLink.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HrbNavLink, selectors: [["hrb-nav-link"]], inputs: { as: "as", disabled: "disabled", href: "href", pAriaLabel: "pAriaLabel", pAriaLabelledby: "pAriaLabelledby", pAriaRole: "pAriaRole", rel: "rel", styleType: "styleType", target: "target", type: "type" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function HrbNavLink_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    HrbNavLink = __decorate([
        ProxyCmp({
            inputs: ['as', 'disabled', 'href', 'pAriaLabel', 'pAriaLabelledby', 'pAriaRole', 'rel', 'styleType', 'target', 'type']
        })
    ], HrbNavLink);
    return HrbNavLink;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HrbNavLink, [{
        type: Component,
        args: [{
                selector: 'hrb-nav-link',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['as', 'disabled', 'href', 'pAriaLabel', 'pAriaLabelledby', 'pAriaRole', 'rel', 'styleType', 'target', 'type'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var HrbNavLogo = /** @class */ (function () {
    function HrbNavLogo(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    HrbNavLogo.ɵfac = function HrbNavLogo_Factory(t) { return new (t || HrbNavLogo)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    HrbNavLogo.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HrbNavLogo, selectors: [["hrb-nav-logo"]], inputs: { height: "height", href: "href", pAriaLabel: "pAriaLabel", rel: "rel", target: "target", width: "width" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function HrbNavLogo_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    HrbNavLogo = __decorate([
        ProxyCmp({
            inputs: ['height', 'href', 'pAriaLabel', 'rel', 'target', 'width']
        })
    ], HrbNavLogo);
    return HrbNavLogo;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HrbNavLogo, [{
        type: Component,
        args: [{
                selector: 'hrb-nav-logo',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['height', 'href', 'pAriaLabel', 'rel', 'target', 'width'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var HrbNavSecondary = /** @class */ (function () {
    function HrbNavSecondary(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    HrbNavSecondary.ɵfac = function HrbNavSecondary_Factory(t) { return new (t || HrbNavSecondary)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    HrbNavSecondary.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HrbNavSecondary, selectors: [["hrb-nav-secondary"]], inputs: { hiddenTitle: "hiddenTitle", stacked: "stacked" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function HrbNavSecondary_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    HrbNavSecondary = __decorate([
        ProxyCmp({
            inputs: ['hiddenTitle', 'stacked']
        })
    ], HrbNavSecondary);
    return HrbNavSecondary;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HrbNavSecondary, [{
        type: Component,
        args: [{
                selector: 'hrb-nav-secondary',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['hiddenTitle', 'stacked'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var HrbNavSecondaryItem = /** @class */ (function () {
    function HrbNavSecondaryItem(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['linkClicked']);
    }
    HrbNavSecondaryItem.ɵfac = function HrbNavSecondaryItem_Factory(t) { return new (t || HrbNavSecondaryItem)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    HrbNavSecondaryItem.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HrbNavSecondaryItem, selectors: [["hrb-nav-secondary-item"]], inputs: { as: "as", disabled: "disabled", href: "href", icon: "icon", iconPosition: "iconPosition", isCurrent: "isCurrent", linkText: "linkText", rel: "rel", target: "target" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function HrbNavSecondaryItem_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    HrbNavSecondaryItem = __decorate([
        ProxyCmp({
            inputs: ['as', 'disabled', 'href', 'icon', 'iconPosition', 'isCurrent', 'linkText', 'rel', 'target']
        })
    ], HrbNavSecondaryItem);
    return HrbNavSecondaryItem;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HrbNavSecondaryItem, [{
        type: Component,
        args: [{
                selector: 'hrb-nav-secondary-item',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['as', 'disabled', 'href', 'icon', 'iconPosition', 'isCurrent', 'linkText', 'rel', 'target'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var HrbNavbarPrimaryItem = /** @class */ (function () {
    function HrbNavbarPrimaryItem(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    HrbNavbarPrimaryItem.ɵfac = function HrbNavbarPrimaryItem_Factory(t) { return new (t || HrbNavbarPrimaryItem)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    HrbNavbarPrimaryItem.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HrbNavbarPrimaryItem, selectors: [["hrb-navbar-primary-item"]], inputs: { href: "href", rel: "rel", target: "target", text: "text" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function HrbNavbarPrimaryItem_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    HrbNavbarPrimaryItem = __decorate([
        ProxyCmp({
            inputs: ['href', 'rel', 'target', 'text']
        })
    ], HrbNavbarPrimaryItem);
    return HrbNavbarPrimaryItem;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HrbNavbarPrimaryItem, [{
        type: Component,
        args: [{
                selector: 'hrb-navbar-primary-item',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['href', 'rel', 'target', 'text'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var HrbNavbarSecondaryItem = /** @class */ (function () {
    function HrbNavbarSecondaryItem(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    HrbNavbarSecondaryItem.ɵfac = function HrbNavbarSecondaryItem_Factory(t) { return new (t || HrbNavbarSecondaryItem)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    HrbNavbarSecondaryItem.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HrbNavbarSecondaryItem, selectors: [["hrb-navbar-secondary-item"]], inputs: { hideOnSmall: "hideOnSmall", href: "href", icon: "icon", rel: "rel", target: "target", text: "text" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function HrbNavbarSecondaryItem_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    HrbNavbarSecondaryItem = __decorate([
        ProxyCmp({
            inputs: ['hideOnSmall', 'href', 'icon', 'rel', 'target', 'text']
        })
    ], HrbNavbarSecondaryItem);
    return HrbNavbarSecondaryItem;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HrbNavbarSecondaryItem, [{
        type: Component,
        args: [{
                selector: 'hrb-navbar-secondary-item',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['hideOnSmall', 'href', 'icon', 'rel', 'target', 'text'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var HrbOptionCard = /** @class */ (function () {
    function HrbOptionCard(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['isSelected', 'isExpanded']);
    }
    HrbOptionCard.ɵfac = function HrbOptionCard_Factory(t) { return new (t || HrbOptionCard)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    HrbOptionCard.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HrbOptionCard, selectors: [["hrb-option-card"]], inputs: { badgeIcon: "badgeIcon", badgeImage: "badgeImage", badgeImageAlt: "badgeImageAlt", badgeSubtitle: "badgeSubtitle", badgeText: "badgeText", badgeTheme: "badgeTheme", badgeTitle: "badgeTitle", custom: "custom", disabled: "disabled", expands: "expands", icon: "icon", selected: "selected", selectedIcon: "selectedIcon", theme: "theme" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function HrbOptionCard_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    HrbOptionCard = __decorate([
        ProxyCmp({
            inputs: ['badgeIcon', 'badgeImage', 'badgeImageAlt', 'badgeSubtitle', 'badgeText', 'badgeTheme', 'badgeTitle', 'custom', 'disabled', 'expands', 'icon', 'selected', 'selectedIcon', 'theme'],
            methods: ['selectOption']
        })
    ], HrbOptionCard);
    return HrbOptionCard;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HrbOptionCard, [{
        type: Component,
        args: [{
                selector: 'hrb-option-card',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['badgeIcon', 'badgeImage', 'badgeImageAlt', 'badgeSubtitle', 'badgeText', 'badgeTheme', 'badgeTitle', 'custom', 'disabled', 'expands', 'icon', 'selected', 'selectedIcon', 'theme'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var HrbOverflowItem = /** @class */ (function () {
    function HrbOverflowItem(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    HrbOverflowItem.ɵfac = function HrbOverflowItem_Factory(t) { return new (t || HrbOverflowItem)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    HrbOverflowItem.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HrbOverflowItem, selectors: [["hrb-overflow-item"]], inputs: { as: "as", disabled: "disabled", href: "href", icon: "icon", label: "label", pAriaLabel: "pAriaLabel", pAriaLabelledby: "pAriaLabelledby", pAriaRole: "pAriaRole", rel: "rel", target: "target", theme: "theme", type: "type" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function HrbOverflowItem_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    HrbOverflowItem = __decorate([
        ProxyCmp({
            inputs: ['as', 'disabled', 'href', 'icon', 'label', 'pAriaLabel', 'pAriaLabelledby', 'pAriaRole', 'rel', 'target', 'theme', 'type']
        })
    ], HrbOverflowItem);
    return HrbOverflowItem;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HrbOverflowItem, [{
        type: Component,
        args: [{
                selector: 'hrb-overflow-item',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['as', 'disabled', 'href', 'icon', 'label', 'pAriaLabel', 'pAriaLabelledby', 'pAriaRole', 'rel', 'target', 'theme', 'type'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var HrbOverflowMenu = /** @class */ (function () {
    function HrbOverflowMenu(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['hrbBlur', 'hrbChange', 'hrbFocus', 'hrbInput']);
    }
    HrbOverflowMenu.ɵfac = function HrbOverflowMenu_Factory(t) { return new (t || HrbOverflowMenu)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    HrbOverflowMenu.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HrbOverflowMenu, selectors: [["hrb-overflow-menu"]], inputs: { as: "as", overflowId: "overflowId" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function HrbOverflowMenu_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    HrbOverflowMenu = __decorate([
        ProxyCmp({
            inputs: ['as', 'overflowId'],
            methods: ['getElement', 'setFocus', 'toggle']
        })
    ], HrbOverflowMenu);
    return HrbOverflowMenu;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HrbOverflowMenu, [{
        type: Component,
        args: [{
                selector: 'hrb-overflow-menu',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['as', 'overflowId'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var HrbRadialProgressMeter = /** @class */ (function () {
    function HrbRadialProgressMeter(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['animationDone']);
    }
    HrbRadialProgressMeter.ɵfac = function HrbRadialProgressMeter_Factory(t) { return new (t || HrbRadialProgressMeter)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    HrbRadialProgressMeter.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HrbRadialProgressMeter, selectors: [["hrb-radial-progress-meter"]], inputs: { currentPercentage: "currentPercentage", inputId: "inputId", size: "size", startPercentage: "startPercentage", theme: "theme" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function HrbRadialProgressMeter_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    HrbRadialProgressMeter = __decorate([
        ProxyCmp({
            inputs: ['currentPercentage', 'inputId', 'size', 'startPercentage', 'theme']
        })
    ], HrbRadialProgressMeter);
    return HrbRadialProgressMeter;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HrbRadialProgressMeter, [{
        type: Component,
        args: [{
                selector: 'hrb-radial-progress-meter',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['currentPercentage', 'inputId', 'size', 'startPercentage', 'theme'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var HrbRadio = /** @class */ (function () {
    function HrbRadio(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['hrbBlur', 'hrbChange', 'hrbFocus', 'hrbInput']);
    }
    HrbRadio.ɵfac = function HrbRadio_Factory(t) { return new (t || HrbRadio)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    HrbRadio.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HrbRadio, selectors: [["hrb-radio"]], inputs: { autoIdentifier: "autoIdentifier", checked: "checked", dataVariant: "dataVariant", disabled: "disabled", errorLabel: "errorLabel", hasError: "hasError", helperText: "helperText", iconTheme: "iconTheme", inputId: "inputId", name: "name", optionIcon: "optionIcon", required: "required", theme: "theme", value: "value" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function HrbRadio_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    HrbRadio = __decorate([
        ProxyCmp({
            inputs: ['autoIdentifier', 'checked', 'dataVariant', 'disabled', 'errorLabel', 'hasError', 'helperText', 'iconTheme', 'inputId', 'name', 'optionIcon', 'required', 'theme', 'value'],
            methods: ['getElement', 'setFocus']
        })
    ], HrbRadio);
    return HrbRadio;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HrbRadio, [{
        type: Component,
        args: [{
                selector: 'hrb-radio',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['autoIdentifier', 'checked', 'dataVariant', 'disabled', 'errorLabel', 'hasError', 'helperText', 'iconTheme', 'inputId', 'name', 'optionIcon', 'required', 'theme', 'value'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var HrbRadioGroup = /** @class */ (function () {
    function HrbRadioGroup(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    HrbRadioGroup.ɵfac = function HrbRadioGroup_Factory(t) { return new (t || HrbRadioGroup)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    HrbRadioGroup.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HrbRadioGroup, selectors: [["hrb-radio-group"]], ngContentSelectors: _c0, decls: 1, vars: 0, template: function HrbRadioGroup_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    HrbRadioGroup = __decorate([
        ProxyCmp({})
    ], HrbRadioGroup);
    return HrbRadioGroup;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HrbRadioGroup, [{
        type: Component,
        args: [{
                selector: 'hrb-radio-group',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: [],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var HrbRadioGroupColumns = /** @class */ (function () {
    function HrbRadioGroupColumns(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    HrbRadioGroupColumns.ɵfac = function HrbRadioGroupColumns_Factory(t) { return new (t || HrbRadioGroupColumns)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    HrbRadioGroupColumns.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HrbRadioGroupColumns, selectors: [["hrb-radio-group-columns"]], ngContentSelectors: _c0, decls: 1, vars: 0, template: function HrbRadioGroupColumns_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    HrbRadioGroupColumns = __decorate([
        ProxyCmp({})
    ], HrbRadioGroupColumns);
    return HrbRadioGroupColumns;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HrbRadioGroupColumns, [{
        type: Component,
        args: [{
                selector: 'hrb-radio-group-columns',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: [],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var HrbRadioGroupError = /** @class */ (function () {
    function HrbRadioGroupError(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    HrbRadioGroupError.ɵfac = function HrbRadioGroupError_Factory(t) { return new (t || HrbRadioGroupError)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    HrbRadioGroupError.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HrbRadioGroupError, selectors: [["hrb-radio-group-error"]], ngContentSelectors: _c0, decls: 1, vars: 0, template: function HrbRadioGroupError_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    HrbRadioGroupError = __decorate([
        ProxyCmp({})
    ], HrbRadioGroupError);
    return HrbRadioGroupError;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HrbRadioGroupError, [{
        type: Component,
        args: [{
                selector: 'hrb-radio-group-error',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: [],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var HrbRadioGroupHeader = /** @class */ (function () {
    function HrbRadioGroupHeader(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    HrbRadioGroupHeader.ɵfac = function HrbRadioGroupHeader_Factory(t) { return new (t || HrbRadioGroupHeader)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    HrbRadioGroupHeader.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HrbRadioGroupHeader, selectors: [["hrb-radio-group-header"]], ngContentSelectors: _c0, decls: 1, vars: 0, template: function HrbRadioGroupHeader_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    HrbRadioGroupHeader = __decorate([
        ProxyCmp({})
    ], HrbRadioGroupHeader);
    return HrbRadioGroupHeader;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HrbRadioGroupHeader, [{
        type: Component,
        args: [{
                selector: 'hrb-radio-group-header',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: [],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var HrbRadioGroupHelper = /** @class */ (function () {
    function HrbRadioGroupHelper(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    HrbRadioGroupHelper.ɵfac = function HrbRadioGroupHelper_Factory(t) { return new (t || HrbRadioGroupHelper)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    HrbRadioGroupHelper.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HrbRadioGroupHelper, selectors: [["hrb-radio-group-helper"]], ngContentSelectors: _c0, decls: 1, vars: 0, template: function HrbRadioGroupHelper_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    HrbRadioGroupHelper = __decorate([
        ProxyCmp({})
    ], HrbRadioGroupHelper);
    return HrbRadioGroupHelper;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HrbRadioGroupHelper, [{
        type: Component,
        args: [{
                selector: 'hrb-radio-group-helper',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: [],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var HrbResetGlobal = /** @class */ (function () {
    function HrbResetGlobal(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    HrbResetGlobal.ɵfac = function HrbResetGlobal_Factory(t) { return new (t || HrbResetGlobal)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    HrbResetGlobal.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HrbResetGlobal, selectors: [["hrb-reset-global"]], inputs: { theme: "theme" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function HrbResetGlobal_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    HrbResetGlobal = __decorate([
        ProxyCmp({
            inputs: ['theme']
        })
    ], HrbResetGlobal);
    return HrbResetGlobal;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HrbResetGlobal, [{
        type: Component,
        args: [{
                selector: 'hrb-reset-global',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['theme'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var HrbRule = /** @class */ (function () {
    function HrbRule(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    HrbRule.ɵfac = function HrbRule_Factory(t) { return new (t || HrbRule)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    HrbRule.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HrbRule, selectors: [["hrb-rule"]], inputs: { vertical: "vertical" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function HrbRule_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    HrbRule = __decorate([
        ProxyCmp({
            inputs: ['vertical']
        })
    ], HrbRule);
    return HrbRule;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HrbRule, [{
        type: Component,
        args: [{
                selector: 'hrb-rule',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['vertical'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var HrbSection = /** @class */ (function () {
    function HrbSection(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    HrbSection.ɵfac = function HrbSection_Factory(t) { return new (t || HrbSection)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    HrbSection.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HrbSection, selectors: [["hrb-section"]], inputs: { dataTheme: "dataTheme" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function HrbSection_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    HrbSection = __decorate([
        ProxyCmp({
            inputs: ['dataTheme']
        })
    ], HrbSection);
    return HrbSection;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HrbSection, [{
        type: Component,
        args: [{
                selector: 'hrb-section',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['dataTheme'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var HrbSelect = /** @class */ (function () {
    function HrbSelect(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['hrbBlur', 'hrbChange', 'hrbFocus', 'hrbInput']);
    }
    HrbSelect.ɵfac = function HrbSelect_Factory(t) { return new (t || HrbSelect)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    HrbSelect.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HrbSelect, selectors: [["hrb-select"]], inputs: { autoIdentifier: "autoIdentifier", dataInput: "dataInput", disabled: "disabled", errorLabel: "errorLabel", hasError: "hasError", helperText: "helperText", label: "label", loading: "loading", name: "name", value: "value" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function HrbSelect_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    HrbSelect = __decorate([
        ProxyCmp({
            inputs: ['autoIdentifier', 'dataInput', 'disabled', 'errorLabel', 'hasError', 'helperText', 'label', 'loading', 'name', 'value'],
            methods: ['getElement', 'setFocus']
        })
    ], HrbSelect);
    return HrbSelect;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HrbSelect, [{
        type: Component,
        args: [{
                selector: 'hrb-select',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['autoIdentifier', 'dataInput', 'disabled', 'errorLabel', 'hasError', 'helperText', 'label', 'loading', 'name', 'value'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var HrbSelectCustom = /** @class */ (function () {
    function HrbSelectCustom(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['hrbSelectBlur', 'hrbSelectChange', 'hrbSelectFocus', 'hrbSelectInput', 'bodyClicked']);
    }
    HrbSelectCustom.ɵfac = function HrbSelectCustom_Factory(t) { return new (t || HrbSelectCustom)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    HrbSelectCustom.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HrbSelectCustom, selectors: [["hrb-select-custom"]], inputs: { autoIdentifier: "autoIdentifier", disabled: "disabled", errorLabel: "errorLabel", hasError: "hasError", helperText: "helperText", label: "label", loading: "loading", optionGroupName: "optionGroupName", value: "value" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function HrbSelectCustom_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    HrbSelectCustom = __decorate([
        ProxyCmp({
            inputs: ['autoIdentifier', 'disabled', 'errorLabel', 'hasError', 'helperText', 'label', 'loading', 'optionGroupName', 'value'],
            methods: ['updateOptionList']
        })
    ], HrbSelectCustom);
    return HrbSelectCustom;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HrbSelectCustom, [{
        type: Component,
        args: [{
                selector: 'hrb-select-custom',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['autoIdentifier', 'disabled', 'errorLabel', 'hasError', 'helperText', 'label', 'loading', 'optionGroupName', 'value'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var HrbSelectNative = /** @class */ (function () {
    function HrbSelectNative(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['hrbSelectBlur', 'hrbSelectChange', 'hrbSelectFocus', 'hrbSelectInput']);
    }
    HrbSelectNative.ɵfac = function HrbSelectNative_Factory(t) { return new (t || HrbSelectNative)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    HrbSelectNative.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HrbSelectNative, selectors: [["hrb-select-native"]], inputs: { autoIdentifier: "autoIdentifier", disabled: "disabled", errorLabel: "errorLabel", hasError: "hasError", helperText: "helperText", label: "label", loading: "loading", value: "value" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function HrbSelectNative_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    HrbSelectNative = __decorate([
        ProxyCmp({
            inputs: ['autoIdentifier', 'disabled', 'errorLabel', 'hasError', 'helperText', 'label', 'loading', 'value']
        })
    ], HrbSelectNative);
    return HrbSelectNative;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HrbSelectNative, [{
        type: Component,
        args: [{
                selector: 'hrb-select-native',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['autoIdentifier', 'disabled', 'errorLabel', 'hasError', 'helperText', 'label', 'loading', 'value'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var HrbSelectOption = /** @class */ (function () {
    function HrbSelectOption(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['optionClick', 'optionMouseEnter']);
    }
    HrbSelectOption.ɵfac = function HrbSelectOption_Factory(t) { return new (t || HrbSelectOption)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    HrbSelectOption.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HrbSelectOption, selectors: [["hrb-select-option"]], inputs: { baseId: "baseId", currentlyFocusedOptionIndex: "currentlyFocusedOptionIndex", currentlySelectedOptionIndex: "currentlySelectedOptionIndex", index: "index", option: "option" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function HrbSelectOption_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    HrbSelectOption = __decorate([
        ProxyCmp({
            inputs: ['baseId', 'currentlyFocusedOptionIndex', 'currentlySelectedOptionIndex', 'index', 'option']
        })
    ], HrbSelectOption);
    return HrbSelectOption;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HrbSelectOption, [{
        type: Component,
        args: [{
                selector: 'hrb-select-option',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['baseId', 'currentlyFocusedOptionIndex', 'currentlySelectedOptionIndex', 'index', 'option'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var HrbSideNavGroup = /** @class */ (function () {
    function HrbSideNavGroup(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    HrbSideNavGroup.ɵfac = function HrbSideNavGroup_Factory(t) { return new (t || HrbSideNavGroup)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    HrbSideNavGroup.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HrbSideNavGroup, selectors: [["hrb-side-nav-group"]], inputs: { dataIcon: "dataIcon", dataLabel: "dataLabel" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function HrbSideNavGroup_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    HrbSideNavGroup = __decorate([
        ProxyCmp({
            inputs: ['dataIcon', 'dataLabel']
        })
    ], HrbSideNavGroup);
    return HrbSideNavGroup;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HrbSideNavGroup, [{
        type: Component,
        args: [{
                selector: 'hrb-side-nav-group',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['dataIcon', 'dataLabel'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var HrbSideNavItem = /** @class */ (function () {
    function HrbSideNavItem(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    HrbSideNavItem.ɵfac = function HrbSideNavItem_Factory(t) { return new (t || HrbSideNavItem)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    HrbSideNavItem.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HrbSideNavItem, selectors: [["hrb-side-nav-item"]], inputs: { dataRoute: "dataRoute", dataState: "dataState" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function HrbSideNavItem_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    HrbSideNavItem = __decorate([
        ProxyCmp({
            inputs: ['dataRoute', 'dataState']
        })
    ], HrbSideNavItem);
    return HrbSideNavItem;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HrbSideNavItem, [{
        type: Component,
        args: [{
                selector: 'hrb-side-nav-item',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['dataRoute', 'dataState'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var HrbSimpleSelect = /** @class */ (function () {
    function HrbSimpleSelect(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['hrbBlur', 'hrbChange', 'hrbFocus', 'hrbInput']);
    }
    HrbSimpleSelect.ɵfac = function HrbSimpleSelect_Factory(t) { return new (t || HrbSimpleSelect)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    HrbSimpleSelect.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HrbSimpleSelect, selectors: [["hrb-simple-select"]], inputs: { autocomplete: "autocomplete", dataId: "dataId", dataLabel: "dataLabel", dataTabindex: "dataTabindex", disabled: "disabled", inputId: "inputId", multiple: "multiple", name: "name", required: "required", size: "size" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function HrbSimpleSelect_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    HrbSimpleSelect = __decorate([
        ProxyCmp({
            inputs: ['autocomplete', 'dataId', 'dataLabel', 'dataTabindex', 'disabled', 'inputId', 'multiple', 'name', 'required', 'size']
        })
    ], HrbSimpleSelect);
    return HrbSimpleSelect;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HrbSimpleSelect, [{
        type: Component,
        args: [{
                selector: 'hrb-simple-select',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['autocomplete', 'dataId', 'dataLabel', 'dataTabindex', 'disabled', 'inputId', 'multiple', 'name', 'required', 'size'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var HrbSpacer = /** @class */ (function () {
    function HrbSpacer(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    HrbSpacer.ɵfac = function HrbSpacer_Factory(t) { return new (t || HrbSpacer)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    HrbSpacer.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HrbSpacer, selectors: [["hrb-spacer"]], inputs: { d: "d", lg: "lg", md: "md", sm: "sm" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function HrbSpacer_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    HrbSpacer = __decorate([
        ProxyCmp({
            inputs: ['d', 'lg', 'md', 'sm']
        })
    ], HrbSpacer);
    return HrbSpacer;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HrbSpacer, [{
        type: Component,
        args: [{
                selector: 'hrb-spacer',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['d', 'lg', 'md', 'sm'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var HrbSpacingGlobal = /** @class */ (function () {
    function HrbSpacingGlobal(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    HrbSpacingGlobal.ɵfac = function HrbSpacingGlobal_Factory(t) { return new (t || HrbSpacingGlobal)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    HrbSpacingGlobal.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HrbSpacingGlobal, selectors: [["hrb-spacing-global"]], ngContentSelectors: _c0, decls: 1, vars: 0, template: function HrbSpacingGlobal_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    HrbSpacingGlobal = __decorate([
        ProxyCmp({})
    ], HrbSpacingGlobal);
    return HrbSpacingGlobal;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HrbSpacingGlobal, [{
        type: Component,
        args: [{
                selector: 'hrb-spacing-global',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: [],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var HrbSpruceGlobal = /** @class */ (function () {
    function HrbSpruceGlobal(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    HrbSpruceGlobal.ɵfac = function HrbSpruceGlobal_Factory(t) { return new (t || HrbSpruceGlobal)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    HrbSpruceGlobal.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HrbSpruceGlobal, selectors: [["hrb-spruce-global"]], ngContentSelectors: _c0, decls: 1, vars: 0, template: function HrbSpruceGlobal_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    HrbSpruceGlobal = __decorate([
        ProxyCmp({})
    ], HrbSpruceGlobal);
    return HrbSpruceGlobal;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HrbSpruceGlobal, [{
        type: Component,
        args: [{
                selector: 'hrb-spruce-global',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: [],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var HrbStep = /** @class */ (function () {
    function HrbStep(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    HrbStep.ɵfac = function HrbStep_Factory(t) { return new (t || HrbStep)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    HrbStep.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HrbStep, selectors: [["hrb-step"]], inputs: { dataState: "dataState" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function HrbStep_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    HrbStep = __decorate([
        ProxyCmp({
            inputs: ['dataState']
        })
    ], HrbStep);
    return HrbStep;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HrbStep, [{
        type: Component,
        args: [{
                selector: 'hrb-step',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['dataState'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var HrbStepIndicator = /** @class */ (function () {
    function HrbStepIndicator(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['expandCollapsedToggle']);
    }
    HrbStepIndicator.ɵfac = function HrbStepIndicator_Factory(t) { return new (t || HrbStepIndicator)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    HrbStepIndicator.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HrbStepIndicator, selectors: [["hrb-step-indicator"]], ngContentSelectors: _c0, decls: 1, vars: 0, template: function HrbStepIndicator_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    HrbStepIndicator = __decorate([
        ProxyCmp({
            methods: ['toggleEl', 'getChildStepInfo']
        })
    ], HrbStepIndicator);
    return HrbStepIndicator;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HrbStepIndicator, [{
        type: Component,
        args: [{
                selector: 'hrb-step-indicator',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: [],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var HrbSummaryCard = /** @class */ (function () {
    function HrbSummaryCard(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    HrbSummaryCard.ɵfac = function HrbSummaryCard_Factory(t) { return new (t || HrbSummaryCard)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    HrbSummaryCard.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HrbSummaryCard, selectors: [["hrb-summary-card"]], inputs: { dataId: "dataId", dataInput: "dataInput", dataType: "dataType" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function HrbSummaryCard_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    HrbSummaryCard = __decorate([
        ProxyCmp({
            inputs: ['dataId', 'dataInput', 'dataType']
        })
    ], HrbSummaryCard);
    return HrbSummaryCard;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HrbSummaryCard, [{
        type: Component,
        args: [{
                selector: 'hrb-summary-card',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['dataId', 'dataInput', 'dataType'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var HrbSummaryCardButton = /** @class */ (function () {
    function HrbSummaryCardButton(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['editButtonClick']);
    }
    HrbSummaryCardButton.ɵfac = function HrbSummaryCardButton_Factory(t) { return new (t || HrbSummaryCardButton)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    HrbSummaryCardButton.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HrbSummaryCardButton, selectors: [["hrb-summary-card-button"]], inputs: { dataLabel: "dataLabel" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function HrbSummaryCardButton_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    HrbSummaryCardButton = __decorate([
        ProxyCmp({
            inputs: ['dataLabel']
        })
    ], HrbSummaryCardButton);
    return HrbSummaryCardButton;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HrbSummaryCardButton, [{
        type: Component,
        args: [{
                selector: 'hrb-summary-card-button',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['dataLabel'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var HrbSummaryCardTitle = /** @class */ (function () {
    function HrbSummaryCardTitle(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    HrbSummaryCardTitle.ɵfac = function HrbSummaryCardTitle_Factory(t) { return new (t || HrbSummaryCardTitle)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    HrbSummaryCardTitle.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HrbSummaryCardTitle, selectors: [["hrb-summary-card-title"]], ngContentSelectors: _c0, decls: 1, vars: 0, template: function HrbSummaryCardTitle_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    HrbSummaryCardTitle = __decorate([
        ProxyCmp({})
    ], HrbSummaryCardTitle);
    return HrbSummaryCardTitle;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HrbSummaryCardTitle, [{
        type: Component,
        args: [{
                selector: 'hrb-summary-card-title',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: [],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var HrbSummaryCardValueItem = /** @class */ (function () {
    function HrbSummaryCardValueItem(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    HrbSummaryCardValueItem.ɵfac = function HrbSummaryCardValueItem_Factory(t) { return new (t || HrbSummaryCardValueItem)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    HrbSummaryCardValueItem.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HrbSummaryCardValueItem, selectors: [["hrb-summary-card-value-item"]], inputs: { dataLabel: "dataLabel", dataValue: "dataValue" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function HrbSummaryCardValueItem_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    HrbSummaryCardValueItem = __decorate([
        ProxyCmp({
            inputs: ['dataLabel', 'dataValue']
        })
    ], HrbSummaryCardValueItem);
    return HrbSummaryCardValueItem;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HrbSummaryCardValueItem, [{
        type: Component,
        args: [{
                selector: 'hrb-summary-card-value-item',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['dataLabel', 'dataValue'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var HrbSummaryCardValueList = /** @class */ (function () {
    function HrbSummaryCardValueList(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    HrbSummaryCardValueList.ɵfac = function HrbSummaryCardValueList_Factory(t) { return new (t || HrbSummaryCardValueList)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    HrbSummaryCardValueList.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HrbSummaryCardValueList, selectors: [["hrb-summary-card-value-list"]], ngContentSelectors: _c0, decls: 1, vars: 0, template: function HrbSummaryCardValueList_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    HrbSummaryCardValueList = __decorate([
        ProxyCmp({})
    ], HrbSummaryCardValueList);
    return HrbSummaryCardValueList;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HrbSummaryCardValueList, [{
        type: Component,
        args: [{
                selector: 'hrb-summary-card-value-list',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: [],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var HrbText = /** @class */ (function () {
    function HrbText(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    HrbText.ɵfac = function HrbText_Factory(t) { return new (t || HrbText)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    HrbText.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HrbText, selectors: [["hrb-text"]], inputs: { as: "as", autoIdentifier: "autoIdentifier", dataType: "dataType", dataVariant: "dataVariant", styleType: "styleType" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function HrbText_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    HrbText = __decorate([
        ProxyCmp({
            inputs: ['as', 'autoIdentifier', 'dataType', 'dataVariant', 'styleType']
        })
    ], HrbText);
    return HrbText;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HrbText, [{
        type: Component,
        args: [{
                selector: 'hrb-text',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['as', 'autoIdentifier', 'dataType', 'dataVariant', 'styleType'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var HrbTextarea = /** @class */ (function () {
    function HrbTextarea(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['hrbBlur', 'hrbChange', 'hrbFocus', 'hrbInput']);
    }
    HrbTextarea.ɵfac = function HrbTextarea_Factory(t) { return new (t || HrbTextarea)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    HrbTextarea.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HrbTextarea, selectors: [["hrb-textarea"]], inputs: { autocomplete: "autocomplete", cols: "cols", disableResize: "disableResize", disabled: "disabled", errorLabel: "errorLabel", hasError: "hasError", helperText: "helperText", label: "label", loading: "loading", maxlength: "maxlength", minlength: "minlength", name: "name", pattern: "pattern", readonly: "readonly", required: "required", rows: "rows", textareaId: "textareaId", value: "value" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function HrbTextarea_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    HrbTextarea = __decorate([
        ProxyCmp({
            inputs: ['autocomplete', 'cols', 'disableResize', 'disabled', 'errorLabel', 'hasError', 'helperText', 'label', 'loading', 'maxlength', 'minlength', 'name', 'pattern', 'readonly', 'required', 'rows', 'textareaId', 'value'],
            methods: ['setFocus']
        })
    ], HrbTextarea);
    return HrbTextarea;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HrbTextarea, [{
        type: Component,
        args: [{
                selector: 'hrb-textarea',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['autocomplete', 'cols', 'disableResize', 'disabled', 'errorLabel', 'hasError', 'helperText', 'label', 'loading', 'maxlength', 'minlength', 'name', 'pattern', 'readonly', 'required', 'rows', 'textareaId', 'value'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var HrbToast = /** @class */ (function () {
    function HrbToast(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['actionClicked']);
    }
    HrbToast.ɵfac = function HrbToast_Factory(t) { return new (t || HrbToast)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    HrbToast.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HrbToast, selectors: [["hrb-toast"]], inputs: { autoIdentifier: "autoIdentifier", header: "header", text: "text", toastAction: "toastAction" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function HrbToast_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    HrbToast = __decorate([
        ProxyCmp({
            inputs: ['autoIdentifier', 'header', 'text', 'toastAction']
        })
    ], HrbToast);
    return HrbToast;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HrbToast, [{
        type: Component,
        args: [{
                selector: 'hrb-toast',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['autoIdentifier', 'header', 'text', 'toastAction'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var HrbToggle = /** @class */ (function () {
    function HrbToggle(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['hrbBlur', 'hrbChange', 'hrbFocus', 'hrbInput']);
    }
    HrbToggle.ɵfac = function HrbToggle_Factory(t) { return new (t || HrbToggle)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    HrbToggle.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HrbToggle, selectors: [["hrb-toggle"]], inputs: { autoIdentifier: "autoIdentifier", checked: "checked", dataType: "dataType", dataVariant: "dataVariant", disabled: "disabled" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function HrbToggle_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    HrbToggle = __decorate([
        ProxyCmp({
            inputs: ['autoIdentifier', 'checked', 'dataType', 'dataVariant', 'disabled'],
            methods: ['getElement', 'setFocus']
        })
    ], HrbToggle);
    return HrbToggle;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HrbToggle, [{
        type: Component,
        args: [{
                selector: 'hrb-toggle',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['autoIdentifier', 'checked', 'dataType', 'dataVariant', 'disabled'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var HrbToggleCard = /** @class */ (function () {
    function HrbToggleCard(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    HrbToggleCard.ɵfac = function HrbToggleCard_Factory(t) { return new (t || HrbToggleCard)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    HrbToggleCard.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HrbToggleCard, selectors: [["hrb-toggle-card"]], inputs: { dataType: "dataType", icon: "icon" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function HrbToggleCard_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    HrbToggleCard = __decorate([
        ProxyCmp({
            inputs: ['dataType', 'icon']
        })
    ], HrbToggleCard);
    return HrbToggleCard;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HrbToggleCard, [{
        type: Component,
        args: [{
                selector: 'hrb-toggle-card',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['dataType', 'icon'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var HrbToggleTip = /** @class */ (function () {
    function HrbToggleTip(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    HrbToggleTip.ɵfac = function HrbToggleTip_Factory(t) { return new (t || HrbToggleTip)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    HrbToggleTip.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HrbToggleTip, selectors: [["hrb-toggle-tip"]], inputs: { position: "position" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function HrbToggleTip_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    HrbToggleTip = __decorate([
        ProxyCmp({
            inputs: ['position']
        })
    ], HrbToggleTip);
    return HrbToggleTip;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HrbToggleTip, [{
        type: Component,
        args: [{
                selector: 'hrb-toggle-tip',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['position'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var HrbTooltip = /** @class */ (function () {
    function HrbTooltip(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['tooltipShow']);
    }
    HrbTooltip.ɵfac = function HrbTooltip_Factory(t) { return new (t || HrbTooltip)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    HrbTooltip.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HrbTooltip, selectors: [["hrb-tooltip"]], inputs: { tooltipContent: "tooltipContent", tooltipId: "tooltipId", tooltipPosition: "tooltipPosition", tooltipVisible: "tooltipVisible" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function HrbTooltip_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    HrbTooltip = __decorate([
        ProxyCmp({
            inputs: ['tooltipContent', 'tooltipId', 'tooltipPosition', 'tooltipVisible'],
            methods: ['toggleTooltip']
        })
    ], HrbTooltip);
    return HrbTooltip;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HrbTooltip, [{
        type: Component,
        args: [{
                selector: 'hrb-tooltip',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['tooltipContent', 'tooltipId', 'tooltipPosition', 'tooltipVisible'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var HrbTypographyGlobal = /** @class */ (function () {
    function HrbTypographyGlobal(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    HrbTypographyGlobal.ɵfac = function HrbTypographyGlobal_Factory(t) { return new (t || HrbTypographyGlobal)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    HrbTypographyGlobal.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HrbTypographyGlobal, selectors: [["hrb-typography-global"]], ngContentSelectors: _c0, decls: 1, vars: 0, template: function HrbTypographyGlobal_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    HrbTypographyGlobal = __decorate([
        ProxyCmp({})
    ], HrbTypographyGlobal);
    return HrbTypographyGlobal;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HrbTypographyGlobal, [{
        type: Component,
        args: [{
                selector: 'hrb-typography-global',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: [],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var HrbUtilityGlobal = /** @class */ (function () {
    function HrbUtilityGlobal(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    HrbUtilityGlobal.ɵfac = function HrbUtilityGlobal_Factory(t) { return new (t || HrbUtilityGlobal)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    HrbUtilityGlobal.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HrbUtilityGlobal, selectors: [["hrb-utility-global"]], ngContentSelectors: _c0, decls: 1, vars: 0, template: function HrbUtilityGlobal_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    HrbUtilityGlobal = __decorate([
        ProxyCmp({})
    ], HrbUtilityGlobal);
    return HrbUtilityGlobal;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HrbUtilityGlobal, [{
        type: Component,
        args: [{
                selector: 'hrb-utility-global',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: [],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();
var HrbVideo = /** @class */ (function () {
    function HrbVideo(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['hrbStateChange', 'hrbReady']);
    }
    HrbVideo.ɵfac = function HrbVideo_Factory(t) { return new (t || HrbVideo)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
    HrbVideo.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HrbVideo, selectors: [["hrb-video"]], inputs: { aspectRatio: "aspectRatio", autoplay: "autoplay", height: "height", muted: "muted", pTitle: "pTitle", poster: "poster", posterSrcset: "posterSrcset", removeControls: "removeControls", videoId: "videoId", width: "width" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function HrbVideo_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2, changeDetection: 0 });
    HrbVideo = __decorate([
        ProxyCmp({
            inputs: ['aspectRatio', 'autoplay', 'height', 'muted', 'pTitle', 'poster', 'posterSrcset', 'removeControls', 'videoId', 'width'],
            methods: ['play', 'stop', 'pause']
        })
    ], HrbVideo);
    return HrbVideo;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HrbVideo, [{
        type: Component,
        args: [{
                selector: 'hrb-video',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: '<ng-content></ng-content>',
                // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                inputs: ['aspectRatio', 'autoplay', 'height', 'muted', 'pTitle', 'poster', 'posterSrcset', 'removeControls', 'videoId', 'width'],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, null); })();

var ValueAccessor = /** @class */ (function () {
    function ValueAccessor(el, cdr) {
        this.el = el;
        this.cdr = cdr;
        this.onChange = function () {
            /**/
        };
        this.onTouched = function () {
            /**/
        };
    }
    ValueAccessor.prototype.writeValue = function (value) {
        this.el.nativeElement.value = this.lastValue = value == null ? '' : value;
        this.cdr.markForCheck();
    };
    ValueAccessor.prototype.handleChangeWithCheck = function (value) {
        if (value !== this.lastValue) {
            this.lastValue = value;
            this.onChange(value);
        }
    };
    ValueAccessor.prototype.handleChange = function (value) {
        console.log(' change value ' + value);
        this.onChange(value);
    };
    ValueAccessor.prototype._handleBlurEvent = function () {
        this.onTouched();
    };
    ValueAccessor.prototype.registerOnChange = function (fn) {
        this.onChange = fn;
    };
    ValueAccessor.prototype.registerOnTouched = function (fn) {
        this.onTouched = fn;
    };
    ValueAccessor.ɵfac = function ValueAccessor_Factory(t) { return new (t || ValueAccessor)(i0.ɵɵinject(i0.ElementRef), i0.ɵɵinject(i0.ChangeDetectorRef)); };
    ValueAccessor.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ValueAccessor, factory: ValueAccessor.ɵfac });
    return ValueAccessor;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ValueAccessor, [{
        type: Injectable
    }], function () { return [{ type: i0.ElementRef }, { type: i0.ChangeDetectorRef }]; }, { _handleBlurEvent: [{
            type: HostListener,
            args: ['focusout']
        }] }); })();

var BooleanValueAccessor = /** @class */ (function (_super) {
    __extends(BooleanValueAccessor, _super);
    function BooleanValueAccessor(el, cdr) {
        return _super.call(this, el, cdr) || this;
    }
    BooleanValueAccessor.prototype.writeValue = function (value) {
        this.el.nativeElement.checked = value;
        this.cdr.markForCheck();
    };
    BooleanValueAccessor.prototype.handleCheckedChange = function ($event) {
        var target = $event.target;
        var val = target ? target.checked : false;
        this.handleChange(val);
    };
    BooleanValueAccessor.ɵfac = function BooleanValueAccessor_Factory(t) { return new (t || BooleanValueAccessor)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); };
    BooleanValueAccessor.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: BooleanValueAccessor, selectors: [["hrb-check"], ["hrb-toggle"], ["hrb-checkbox"]], hostBindings: function BooleanValueAccessor_HostBindings(rf, ctx) { if (rf & 1) {
            i0.ɵɵlistener("hrbChange", function BooleanValueAccessor_hrbChange_HostBindingHandler($event) { return ctx.handleCheckedChange($event); });
        } }, features: [i0.ɵɵProvidersFeature([
                {
                    provide: NG_VALUE_ACCESSOR,
                    useExisting: BooleanValueAccessor,
                    multi: true,
                },
            ]), i0.ɵɵInheritDefinitionFeature] });
    return BooleanValueAccessor;
}(ValueAccessor));
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BooleanValueAccessor, [{
        type: Directive,
        args: [{
                /* tslint:disable-next-line:directive-selector */
                selector: "hrb-check, hrb-toggle, hrb-checkbox",
                host: {
                    "(hrbChange)": "handleCheckedChange($event)",
                },
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: BooleanValueAccessor,
                        multi: true,
                    },
                ],
            }]
    }], function () { return [{ type: i0.ElementRef }, { type: i0.ChangeDetectorRef }]; }, null); })();

var TextValueAccessor = /** @class */ (function (_super) {
    __extends(TextValueAccessor, _super);
    function TextValueAccessor(el, cdr) {
        return _super.call(this, el, cdr) || this;
    }
    TextValueAccessor.ɵfac = function TextValueAccessor_Factory(t) { return new (t || TextValueAccessor)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); };
    TextValueAccessor.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: TextValueAccessor, selectors: [["hrb-input"], ["hrb-autocomplete"], ["hrb-textarea"]], hostBindings: function TextValueAccessor_HostBindings(rf, ctx) { if (rf & 1) {
            i0.ɵɵlistener("hrbChange", function TextValueAccessor_hrbChange_HostBindingHandler($event) { return ctx.handleChangeWithCheck($event.target.value); })("hrbInput", function TextValueAccessor_hrbInput_HostBindingHandler($event) { return ctx.handleChangeWithCheck($event.target.value); });
        } }, features: [i0.ɵɵProvidersFeature([
                {
                    provide: NG_VALUE_ACCESSOR,
                    useExisting: TextValueAccessor,
                    multi: true,
                },
            ]), i0.ɵɵInheritDefinitionFeature] });
    return TextValueAccessor;
}(ValueAccessor));
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TextValueAccessor, [{
        type: Directive,
        args: [{
                /* tslint:disable-next-line:directive-selector */
                selector: 'hrb-input, hrb-autocomplete, hrb-textarea',
                host: {
                    '(hrbChange)': 'handleChangeWithCheck($event.target.value)',
                    '(hrbInput)': 'handleChangeWithCheck($event.target.value)',
                },
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: TextValueAccessor,
                        multi: true,
                    },
                ],
            }]
    }], function () { return [{ type: i0.ElementRef }, { type: i0.ChangeDetectorRef }]; }, null); })();

var RadioValueAccessor = /** @class */ (function (_super) {
    __extends(RadioValueAccessor, _super);
    function RadioValueAccessor(el, cdr) {
        return _super.call(this, el, cdr) || this;
    }
    RadioValueAccessor.prototype.writeValue = function (value) {
        this.el.nativeElement.checked = value === this.el.nativeElement.value;
        this.cdr.markForCheck();
    };
    RadioValueAccessor.prototype.handleCheckedChange = function ($event) {
        var detail = $event.detail;
        if (!detail) {
            return;
        }
        var val = detail.value;
        this.handleChange(val);
    };
    RadioValueAccessor.ɵfac = function RadioValueAccessor_Factory(t) { return new (t || RadioValueAccessor)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); };
    RadioValueAccessor.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: RadioValueAccessor, selectors: [["hrb-radio"]], hostBindings: function RadioValueAccessor_HostBindings(rf, ctx) { if (rf & 1) {
            i0.ɵɵlistener("hrbChange", function RadioValueAccessor_hrbChange_HostBindingHandler($event) { return ctx.handleCheckedChange($event); })("hrbInput", function RadioValueAccessor_hrbInput_HostBindingHandler($event) { return ctx.handleCheckedChange($event); });
        } }, features: [i0.ɵɵProvidersFeature([
                {
                    provide: NG_VALUE_ACCESSOR,
                    useExisting: RadioValueAccessor,
                    multi: true,
                },
            ]), i0.ɵɵInheritDefinitionFeature] });
    return RadioValueAccessor;
}(ValueAccessor));
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RadioValueAccessor, [{
        type: Directive,
        args: [{
                /* tslint:disable-next-line:directive-selector */
                selector: 'hrb-radio',
                host: {
                    '(hrbChange)': 'handleCheckedChange($event)',
                    '(hrbInput)': 'handleCheckedChange($event)',
                },
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: RadioValueAccessor,
                        multi: true,
                    },
                ],
            }]
    }], function () { return [{ type: i0.ElementRef }, { type: i0.ChangeDetectorRef }]; }, null); })();

var SelectValueAccessor = /** @class */ (function (_super) {
    __extends(SelectValueAccessor, _super);
    function SelectValueAccessor(el, cdr) {
        var _this = _super.call(this, el, cdr) || this;
        _this.cdr = cdr;
        return _this;
    }
    SelectValueAccessor.prototype.writeValue = function (value) {
        this.el.nativeElement.value = value;
        this.cdr.markForCheck();
    };
    SelectValueAccessor.ɵfac = function SelectValueAccessor_Factory(t) { return new (t || SelectValueAccessor)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); };
    SelectValueAccessor.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: SelectValueAccessor, selectors: [["hrb-select"], ["hrb-simple-select"]], hostBindings: function SelectValueAccessor_HostBindings(rf, ctx) { if (rf & 1) {
            i0.ɵɵlistener("hrbChange", function SelectValueAccessor_hrbChange_HostBindingHandler($event) { return ctx.handleChange($event.detail.value); });
        } }, features: [i0.ɵɵProvidersFeature([
                {
                    provide: NG_VALUE_ACCESSOR,
                    useExisting: SelectValueAccessor,
                    multi: true,
                },
            ]), i0.ɵɵInheritDefinitionFeature] });
    return SelectValueAccessor;
}(ValueAccessor));
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SelectValueAccessor, [{
        type: Directive,
        args: [{
                /* tslint:disable-next-line:directive-selector */
                selector: 'hrb-select, hrb-simple-select',
                host: {
                    '(hrbChange)': 'handleChange($event.detail.value)',
                },
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: SelectValueAccessor,
                        multi: true,
                    },
                ],
            }]
    }], function () { return [{ type: i0.ElementRef }, { type: i0.ChangeDetectorRef }]; }, null); })();

var DECLARATIONS = [
    // proxies
    HrbAccordion,
    HrbAccordionItem,
    HrbAnimationsGlobal,
    HrbAttachmentItem,
    HrbAttachmentList,
    HrbAutocomplete,
    HrbAvatar,
    HrbBadgeLabel,
    HrbBanner,
    HrbButton,
    HrbCard,
    HrbCardContent,
    HrbCardDocument,
    HrbCardExpandable,
    HrbCheckbox,
    HrbCircleButton,
    HrbCircleButtonWithLabel,
    HrbCircled,
    HrbColorsGlobal,
    HrbContainer,
    HrbDataItem,
    HrbDataList,
    HrbDot,
    HrbDotNav,
    HrbDropdownMenu,
    HrbDropdownMenuItem,
    HrbExpandCollapse,
    HrbFlexCol,
    HrbFlexContainer,
    HrbFlexGhost,
    HrbFlexRow,
    HrbFontsGlobal,
    HrbGlobal,
    HrbGridCol,
    HrbGridGhost,
    HrbGridRow,
    HrbIcon,
    HrbIllustration,
    HrbImg,
    HrbInlineAlert,
    HrbInput,
    HrbLabel,
    HrbLayout,
    HrbLink,
    HrbListButton,
    HrbLoader,
    HrbModal,
    HrbNavBar,
    HrbNavLink,
    HrbNavLogo,
    HrbNavbarPrimaryItem,
    HrbNavbarSecondaryItem,
    HrbNavSecondary,
    HrbNavSecondaryItem,
    HrbOptionCard,
    HrbOverflowItem,
    HrbOverflowMenu,
    HrbRadialProgressMeter,
    HrbRadio,
    HrbResetGlobal,
    HrbRule,
    HrbSelect,
    HrbSelectCustom,
    HrbSelectNative,
    HrbSelectOption,
    HrbSpacer,
    HrbSpacingGlobal,
    HrbText,
    HrbTextarea,
    HrbToast,
    HrbToggle,
    HrbToggleCard,
    HrbTooltip,
    HrbTypographyGlobal,
    HrbUtilityGlobal,
    HrbVideo,
    BooleanValueAccessor,
    TextValueAccessor,
    SelectValueAccessor,
    RadioValueAccessor,
];
var BdsNgModule = /** @class */ (function () {
    function BdsNgModule() {
        /**
         * From a consumer standpoint, this will assist us in determining the version
         * and build date of the bds-ng update.
         * While updating this app, please change the 'bds' object's version
         * and build date attributes as shown below.
         */
        try {
            var bds = {
                name: 'H&R Block Design System Components Angular Library',
                package: '@bds/bds-ng',
                version: '0.0.5',
                build: '05/18/2021',
                'ng-version': '11.2.10',
            };
            window.sessionStorage.setItem('bds', JSON.stringify(bds));
        }
        catch (e) {
            window.sessionStorage.setItem('bds', JSON.stringify(e));
        }
    }
    BdsNgModule.ɵfac = function BdsNgModule_Factory(t) { return new (t || BdsNgModule)(); };
    BdsNgModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: BdsNgModule });
    BdsNgModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({});
    return BdsNgModule;
}());
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BdsNgModule, [{
        type: NgModule,
        args: [{
                declarations: DECLARATIONS,
                imports: [],
                exports: DECLARATIONS,
            }]
    }], function () { return []; }, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(BdsNgModule, { declarations: [
        // proxies
        HrbAccordion,
        HrbAccordionItem,
        HrbAnimationsGlobal,
        HrbAttachmentItem,
        HrbAttachmentList,
        HrbAutocomplete,
        HrbAvatar,
        HrbBadgeLabel,
        HrbBanner,
        HrbButton,
        HrbCard,
        HrbCardContent,
        HrbCardDocument,
        HrbCardExpandable,
        HrbCheckbox,
        HrbCircleButton,
        HrbCircleButtonWithLabel,
        HrbCircled,
        HrbColorsGlobal,
        HrbContainer,
        HrbDataItem,
        HrbDataList,
        HrbDot,
        HrbDotNav,
        HrbDropdownMenu,
        HrbDropdownMenuItem,
        HrbExpandCollapse,
        HrbFlexCol,
        HrbFlexContainer,
        HrbFlexGhost,
        HrbFlexRow,
        HrbFontsGlobal,
        HrbGlobal,
        HrbGridCol,
        HrbGridGhost,
        HrbGridRow,
        HrbIcon,
        HrbIllustration,
        HrbImg,
        HrbInlineAlert,
        HrbInput,
        HrbLabel,
        HrbLayout,
        HrbLink,
        HrbListButton,
        HrbLoader,
        HrbModal,
        HrbNavBar,
        HrbNavLink,
        HrbNavLogo,
        HrbNavbarPrimaryItem,
        HrbNavbarSecondaryItem,
        HrbNavSecondary,
        HrbNavSecondaryItem,
        HrbOptionCard,
        HrbOverflowItem,
        HrbOverflowMenu,
        HrbRadialProgressMeter,
        HrbRadio,
        HrbResetGlobal,
        HrbRule,
        HrbSelect,
        HrbSelectCustom,
        HrbSelectNative,
        HrbSelectOption,
        HrbSpacer,
        HrbSpacingGlobal,
        HrbText,
        HrbTextarea,
        HrbToast,
        HrbToggle,
        HrbToggleCard,
        HrbTooltip,
        HrbTypographyGlobal,
        HrbUtilityGlobal,
        HrbVideo,
        BooleanValueAccessor,
        TextValueAccessor,
        SelectValueAccessor,
        RadioValueAccessor], exports: [
        // proxies
        HrbAccordion,
        HrbAccordionItem,
        HrbAnimationsGlobal,
        HrbAttachmentItem,
        HrbAttachmentList,
        HrbAutocomplete,
        HrbAvatar,
        HrbBadgeLabel,
        HrbBanner,
        HrbButton,
        HrbCard,
        HrbCardContent,
        HrbCardDocument,
        HrbCardExpandable,
        HrbCheckbox,
        HrbCircleButton,
        HrbCircleButtonWithLabel,
        HrbCircled,
        HrbColorsGlobal,
        HrbContainer,
        HrbDataItem,
        HrbDataList,
        HrbDot,
        HrbDotNav,
        HrbDropdownMenu,
        HrbDropdownMenuItem,
        HrbExpandCollapse,
        HrbFlexCol,
        HrbFlexContainer,
        HrbFlexGhost,
        HrbFlexRow,
        HrbFontsGlobal,
        HrbGlobal,
        HrbGridCol,
        HrbGridGhost,
        HrbGridRow,
        HrbIcon,
        HrbIllustration,
        HrbImg,
        HrbInlineAlert,
        HrbInput,
        HrbLabel,
        HrbLayout,
        HrbLink,
        HrbListButton,
        HrbLoader,
        HrbModal,
        HrbNavBar,
        HrbNavLink,
        HrbNavLogo,
        HrbNavbarPrimaryItem,
        HrbNavbarSecondaryItem,
        HrbNavSecondary,
        HrbNavSecondaryItem,
        HrbOptionCard,
        HrbOverflowItem,
        HrbOverflowMenu,
        HrbRadialProgressMeter,
        HrbRadio,
        HrbResetGlobal,
        HrbRule,
        HrbSelect,
        HrbSelectCustom,
        HrbSelectNative,
        HrbSelectOption,
        HrbSpacer,
        HrbSpacingGlobal,
        HrbText,
        HrbTextarea,
        HrbToast,
        HrbToggle,
        HrbToggleCard,
        HrbTooltip,
        HrbTypographyGlobal,
        HrbUtilityGlobal,
        HrbVideo,
        BooleanValueAccessor,
        TextValueAccessor,
        SelectValueAccessor,
        RadioValueAccessor] }); })();

export { BdsAiBlockResponse, BdsAiButton, BdsAiContainer, BdsAiDisclaimer, BdsAiFab, BdsAiFeedback, BdsAiGenerating, BdsAiHeader, BdsAiHeaderButton, BdsAiHeaderTitle, BdsAiMessages, BdsAiRule, BdsAiSpinner, BdsAiSuggestedPrompt, BdsAiText, BdsAiUserResponse, BdsBrand, BdsColors, BdsEffects, BdsFlex, BdsGrids, BdsNgModule, BdsSpacing, BdsTypography, BooleanValueAccessor, HrbAccentSection, HrbAccordion, HrbAccordionItem, HrbAnimationsGlobal, HrbAttachmentItem, HrbAttachmentList, HrbAutocomplete, HrbAvatar, HrbBadgeCount, HrbBadgeLabel, HrbBanner, HrbBrandSection, HrbButton, HrbCard, HrbCardContent, HrbCardDocument, HrbCardExpandable, HrbCheckbox, HrbCheckboxGroup, HrbCheckboxGroupColumns, HrbCheckboxGroupError, HrbCheckboxGroupHeader, HrbCheckboxGroupHelper, HrbCircleButton, HrbCircleButtonWithLabel, HrbCircled, HrbColorsGlobal, HrbContainer, HrbContentSection, HrbDataItem, HrbDataList, HrbDot, HrbDotNav, HrbDrawer, HrbDropdownMenu, HrbDropdownMenuItem, HrbExpandCollapse, HrbFlexCol, HrbFlexContainer, HrbFlexGhost, HrbFlexRow, HrbFontsGlobal, HrbFooter, HrbFooterSection, HrbGlobal, HrbGridCol, HrbGridGhost, HrbGridRow, HrbHrbbrandGlobal, HrbIcon, HrbIllustration, HrbImg, HrbInlineAlert, HrbInput, HrbInputGroup, HrbInterstitial, HrbInterstitialActions, HrbInterstitialImage, HrbInterstitialSubtitle, HrbInterstitialTitle, HrbLabel, HrbLayout, HrbLegalSection, HrbLink, HrbListButton, HrbLoader, HrbModal, HrbNavBar, HrbNavLink, HrbNavLogo, HrbNavSecondary, HrbNavSecondaryItem, HrbNavbarPrimaryItem, HrbNavbarSecondaryItem, HrbOptionCard, HrbOverflowItem, HrbOverflowMenu, HrbRadialProgressMeter, HrbRadio, HrbRadioGroup, HrbRadioGroupColumns, HrbRadioGroupError, HrbRadioGroupHeader, HrbRadioGroupHelper, HrbResetGlobal, HrbRule, HrbSection, HrbSelect, HrbSelectCustom, HrbSelectNative, HrbSelectOption, HrbSideNavGroup, HrbSideNavItem, HrbSimpleSelect, HrbSpacer, HrbSpacingGlobal, HrbSpruceGlobal, HrbStep, HrbStepIndicator, HrbSummaryCard, HrbSummaryCardButton, HrbSummaryCardTitle, HrbSummaryCardValueItem, HrbSummaryCardValueList, HrbText, HrbTextarea, HrbToast, HrbToggle, HrbToggleCard, HrbToggleTip, HrbTooltip, HrbTypographyGlobal, HrbUtilityGlobal, HrbVideo, RadioValueAccessor, SelectValueAccessor, TextValueAccessor };
